var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagesBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-400"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.07,
    y: 326.69,
    width: 88.38,
    height: 71.36,
    style: {
      fill: "#9c9c9c"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.44,398.55H209.07a.5.5,0,0,1-.5-.5V326.69a.5.5,0,0,1,.5-.5h88.37a.5.5,0,0,1,.5.5v71.36A.5.5,0,0,1,297.44,398.55Zm-87.87-1h87.37V327.19H209.57Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path--inject-400)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485,441.54H458.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H485a.5.5,0,0,1,.5.5A.5.5,0,0,1,485,441.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,441.54H14.65a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H449.09a.5.5,0,0,1,.5.5A.51.51,0,0,1,449.09,441.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.44,440.41a.5.5,0,0,1-.5-.5V58.78a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V439.91A.51.51,0,0,1,128.44,440.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,1,1,.5,0V387.22A.25.25,0,0,1,119,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,109.53,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,100.07,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,90.62,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.16,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,81.16,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,71.7,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,62.25,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,52.79,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,43.34,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,33.88,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,24.43,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.3,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,478.3,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.84,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,468.84,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.39,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,459.39,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.93,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.5,0V387.22A.25.25,0,0,1,449.93,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.47,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,440.47,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,1,1,.5,0V387.22A.25.25,0,0,1,431,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.56,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,421.56,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,1,1,.5,0V387.22A.25.25,0,0,1,412.11,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.65,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,1,1,.5,0V387.22A.25.25,0,0,1,402.65,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V387.22A.25.25,0,0,1,393.2,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,387.47a.25.25,0,0,1-.25-.25V58.78a.25.25,0,1,1,.5,0V387.22A.25.25,0,0,1,383.74,387.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,440.41a.5.5,0,0,1-.5-.5V58.78a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V439.91A.51.51,0,0,1,375.64,440.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.53,387.94H14.65a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H485.53a.5.5,0,0,1,.5.5A.5.5,0,0,1,485.53,387.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fireplace--inject-400"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.56,
    y: 292.65,
    width: 191.39,
    height: 140.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,434.13H157.56a.5.5,0,0,1-.5-.5v-141a.5.5,0,0,1,.5-.5H349a.5.5,0,0,1,.5.5v141A.5.5,0,0,1,349,434.13Zm-190.89-1H348.45v-140H158.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 321.21,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 321.21,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 330.7,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 339.82,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 339.82,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 349.3,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 358.42,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 358.42,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 367.91,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 377.03,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 377.03,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 386.52,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 395.64,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 395.64,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 405.12,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 321.21,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 321.21,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 330.7,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 339.82,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 339.82,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 349.3,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 358.42,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 358.42,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 367.91,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 377.03,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 377.03,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 386.52,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.32,
    y: 395.64,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 395.64,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 405.12,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.45,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.77,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.1,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.42,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.76,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.74,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.07,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.39,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.71,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.05,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.03,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.36,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.7,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.68,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 414.24,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.34,
    y: 423.73,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.46,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.78,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.12,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.79,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.11,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.45,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.12,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.45,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.78,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.45,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.78,
    y: 302.61,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.11,
    y: 312.09,
    width: 13.86,
    height: 7.3,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.56,
    y: 292.65,
    width: 191.39,
    height: 4.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,297.76H157.56a.5.5,0,0,1-.5-.5v-4.61a.5.5,0,0,1,.5-.5H349a.5.5,0,0,1,.5.5v4.61A.5.5,0,0,1,349,297.76Zm-190.89-1H348.45v-3.61H158.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.61,
    y: 310.98,
    width: 127.3,
    height: 102.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.91,414.26H189.61a.5.5,0,0,1-.5-.5V311a.5.5,0,0,1,.5-.5h127.3a.5.5,0,0,1,.5.5V413.76A.5.5,0,0,1,316.91,414.26Zm-126.8-1h126.3V311.48H190.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.75,
    y: 322.9,
    width: 97.01,
    height: 78.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.76,402.33h-97a.5.5,0,0,1-.5-.5V322.9a.5.5,0,0,1,.5-.5h97a.5.5,0,0,1,.5.5v78.93A.5.5,0,0,1,301.76,402.33Zm-96.51-1h96V323.4h-96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.07,
    y: 326.69,
    width: 88.38,
    height: 71.36,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,398.55H209.07a.5.5,0,0,1-.5-.5V326.69a.5.5,0,0,1,.5-.5h88.37a.5.5,0,0,1,.5.5v71.36A.5.5,0,0,1,297.44,398.55Zm-87.87-1h87.37V327.19H209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-400)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.06,378.79a13.31,13.31,0,0,1,3.7-8.62c3.69-3.7,10.35-2,14.78-4.93s4.44-8.63,4.44-8.63,1.23,2,3,4.19a8.91,8.91,0,0,1,1.72,4.93s7.15-.25,6.9-9.36-1.72-14.3,1.23-17l3-2.71s-1.23,6.16.49,9.37,6.66,2.71,14.05,7.39,7.15,10.84,7.15,10.84a52.86,52.86,0,0,1,2-5.67c1-2.21,1-6.4,1-6.4s1,5.17,5.17,7.88,7.39,4.19,7.64,7.64.25,4.93.25,4.93l2.71-5.91s.24-.5,2.71,2.46S298.56,380,298.56,380v18.73H207.87V386.19S207.87,379,212.06,378.79Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,382.23l-.31-1c1.07-.34,26.17-8.39,27.41-8.64.7-.14.86-2.28.6-3.6-.16-.8-1.26-2.78-4.37-2.31-2.48.38-24.38,9.17-35.62,13.77l-.37-.93c1.33-.54,32.62-13.34,35.84-13.83,3.44-.53,5.2,1.62,5.5,3.11s.3,4.44-1.38,4.77C261,373.8,243.67,379.33,234.64,382.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 366.34,
    width: 1,
    height: 21.7,
    transform: "translate(-162.54 542.01) rotate(-74.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.07,
    y: 367.83,
    width: 1,
    height: 24.39,
    transform: "translate(-169.03 543.56) rotate(-75.97)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 209.07,
    y: 326.69,
    width: 88.38,
    height: 8.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,335.71H209.07a.5.5,0,0,1-.5-.5v-8.52a.5.5,0,0,1,.5-.5h88.37a.5.5,0,0,1,.5.5v8.52A.5.5,0,0,1,297.44,335.71Zm-87.87-1h87.37v-7.52H209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.86,
    y: 288.81,
    width: 206.78,
    height: 4.59,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,293.9H149.86a.51.51,0,0,1-.5-.5v-4.59a.5.5,0,0,1,.5-.5H356.65a.5.5,0,0,1,.5.5v4.59A.51.51,0,0,1,356.65,293.9Zm-206.29-1H356.15v-3.59H150.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.6,
    y: 285.68,
    width: 215.32,
    height: 4.2,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,290.38H145.6a.5.5,0,0,1-.5-.5v-4.2a.5.5,0,0,1,.5-.5H360.91a.5.5,0,0,1,.5.5v4.2A.5.5,0,0,1,360.91,290.38Zm-214.81-1H360.41v-3.2H146.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.86,
    y: 433.32,
    width: 206.78,
    height: 4.59,
    transform: "translate(506.51 871.23) rotate(180)",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,438.41H149.86a.5.5,0,0,1-.5-.5v-4.59a.5.5,0,0,1,.5-.5H356.65a.5.5,0,0,1,.5.5v4.59A.5.5,0,0,1,356.65,438.41Zm-206.29-1H356.15v-3.59H150.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.6,
    y: 436.84,
    width: 215.32,
    height: 4.2,
    transform: "translate(506.51 877.88) rotate(180)",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,441.54H145.6a.5.5,0,0,1-.5-.5v-4.2a.5.5,0,0,1,.5-.5H360.91a.5.5,0,0,1,.5.5V441A.5.5,0,0,1,360.91,441.54Zm-214.81-1H360.41v-3.2H146.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.07,
    y: 384.24,
    width: 88.38,
    height: 4.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,389.47H209.07a.5.5,0,0,1-.5-.5v-4.73a.5.5,0,0,1,.5-.5h88.37a.5.5,0,0,1,.5.5V389A.5.5,0,0,1,297.44,389.47Zm-87.87-1h87.37v-3.73H209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.22,
    y: 380.93,
    width: 5.21,
    height: 11.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,393.26h-5.2a.5.5,0,0,1-.5-.5V380.93a.5.5,0,0,1,.5-.5h5.2a.5.5,0,0,1,.5.5v11.83A.5.5,0,0,1,219.42,393.26Zm-4.7-1h4.2V381.43h-4.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.51,
    y: 380.93,
    width: 5.21,
    height: 11.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,393.26h-5.21a.5.5,0,0,1-.5-.5V380.93a.5.5,0,0,1,.5-.5h5.21a.5.5,0,0,1,.5.5v11.83A.5.5,0,0,1,243.72,393.26Zm-4.71-1h4.21V381.43H239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.8,
    y: 380.93,
    width: 5.21,
    height: 11.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,393.26H262.8a.5.5,0,0,1-.5-.5V380.93a.5.5,0,0,1,.5-.5H268a.5.5,0,0,1,.5.5v11.83A.5.5,0,0,1,268,393.26Zm-4.71-1h4.21V381.43H263.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.09,
    y: 380.93,
    width: 5.21,
    height: 11.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.3,393.26h-5.21a.5.5,0,0,1-.5-.5V380.93a.5.5,0,0,1,.5-.5h5.21a.5.5,0,0,1,.5.5v11.83A.5.5,0,0,1,292.3,393.26Zm-4.71-1h4.21V381.43h-4.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.25,265.16s-8.53-5.6-7.11-6.92,6.63,2.86,6.63,2.86-4.77-5.62-4.85-8.88,4.73,2.11,4.73,2.11-6-9.78-2.14-10.53,5.74,9.74,5.74,9.74-1.61-12.71,2.24-13.46.74,13.6.74,13.6,3.6-6.54,6.05-4.22-5.45,9.3-5.45,9.3,6.13-3,7.7-1.51-1.35,4.58-4,6l-2.68,1.4s7.83,1.52,5,2.27-9.83,4.36-9.83,4.36l-5.86-5Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.03,
    y: 264.84,
    width: 20.25,
    height: 20.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,285.59H157a.5.5,0,0,1-.5-.5V264.84a.5.5,0,0,1,.5-.5h20.25a.5.5,0,0,1,.5.5v20.25A.5.5,0,0,1,177.28,285.59Zm-19.75-1h19.25V265.34H157.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-400"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.15,
    y: 333.44,
    width: 64.18,
    height: 3.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.33,337.53H395.15a.5.5,0,0,1-.5-.5v-3.59a.5.5,0,0,1,.5-.5h64.18a.5.5,0,0,1,.5.5V337A.51.51,0,0,1,459.33,337.53Zm-63.68-1h63.18v-2.59H395.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 439.42,
    width: 43.52,
    height: 1.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,441.64H405.48a.5.5,0,0,1-.5-.5v-1.72a.5.5,0,0,1,.5-.5H449a.5.5,0,0,1,.5.5v1.72A.5.5,0,0,1,449,441.64Zm-43-1H448.5v-.72H406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.86,
    y: 337.61,
    width: 18.75,
    height: 2.43,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.61,340.54H417.86a.51.51,0,0,1-.5-.5v-2.43a.5.5,0,0,1,.5-.5h18.75a.5.5,0,0,1,.5.5V340A.5.5,0,0,1,436.61,340.54Zm-18.25-1h17.75v-1.43H418.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.78,340.26l-4.38-1.34v-.1l-.16.05-.16-.05v.1l-4.38,1.34s-.89,4.41.44,6.61a12.19,12.19,0,0,0,2.42,3.09v89.37h3.35V350a12.33,12.33,0,0,0,2.43-3.09C432.66,344.67,431.78,340.26,431.78,340.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.91,439.83h-3.35a.5.5,0,0,1-.5-.5V350.19a14.45,14.45,0,0,1-2.35-3.06c-1.41-2.34-.54-6.78-.5-7a.49.49,0,0,1,.34-.38l4.2-1.28,0,0a.56.56,0,0,1,.44-.13h0a.55.55,0,0,1,.45.08l.1.1,4.12,1.26a.5.5,0,0,1,.35.38c0,.19.9,4.63-.51,7a14.45,14.45,0,0,1-2.35,3.06v89.14A.5.5,0,0,1,428.91,439.83Zm-2.85-1h2.35V350a.51.51,0,0,1,.19-.39,12.11,12.11,0,0,0,2.31-2.95c1-1.71.59-5,.43-6l-4.09-1.25h0l-4.08,1.25c-.16,1-.6,4.26.43,6a12.11,12.11,0,0,0,2.31,2.95.5.5,0,0,1,.18.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,354.51c0,1.32-1.56,2.38-3.48,2.38s-3.49-1.06-3.49-2.38,1.56-2.38,3.49-2.38S430.72,353.2,430.72,354.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,357.39c-2.24,0-4-1.26-4-2.88s1.75-2.88,4-2.88,4,1.27,4,2.88S429.47,357.39,427.24,357.39Zm0-4.76c-1.62,0-3,.86-3,1.88s1.37,1.88,3,1.88,3-.86,3-1.88S428.86,352.63,427.24,352.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,424.53c0,1.32-1.56,2.38-3.48,2.38s-3.49-1.06-3.49-2.38,1.56-2.38,3.49-2.38S430.72,423.22,430.72,424.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,427.41c-2.24,0-4-1.26-4-2.88s1.75-2.88,4-2.88,4,1.27,4,2.88S429.47,427.41,427.24,427.41Zm0-4.76c-1.62,0-3,.86-3,1.88s1.37,1.88,3,1.88,3-.86,3-1.88S428.86,422.65,427.24,422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,377.85c0,1.32-1.56,2.38-3.48,2.38s-3.49-1.06-3.49-2.38,1.56-2.38,3.49-2.38S430.72,376.54,430.72,377.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,380.73c-2.24,0-4-1.26-4-2.88s1.75-2.88,4-2.88,4,1.27,4,2.88S429.47,380.73,427.24,380.73Zm0-4.76c-1.62,0-3,.86-3,1.88s1.37,1.88,3,1.88,3-.86,3-1.88S428.86,376,427.24,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,383.32c0,1.31-1.56,2.38-3.48,2.38s-3.49-1.07-3.49-2.38,1.56-2.38,3.49-2.38S430.72,382,430.72,383.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,386.2c-2.24,0-4-1.27-4-2.88s1.75-2.88,4-2.88,4,1.26,4,2.88S429.47,386.2,427.24,386.2Zm0-4.76c-1.62,0-3,.86-3,1.88s1.37,1.88,3,1.88,3-.87,3-1.88S428.86,381.44,427.24,381.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.35,
    y: 283.49,
    width: 20.89,
    height: 49.47,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.24,333.46H416.35a.5.5,0,0,1-.5-.5V283.49a.5.5,0,0,1,.5-.5h20.89a.5.5,0,0,1,.5.5V333A.5.5,0,0,1,437.24,333.46Zm-20.39-1h19.89V284H416.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.4,266.07a.3.3,0,0,1-.3-.29,31.51,31.51,0,0,0-3.38-12.93.3.3,0,0,1,.11-.41.29.29,0,0,1,.41.11,32.19,32.19,0,0,1,3.46,13.2.3.3,0,0,1-.28.32Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.88,266.88a.32.32,0,0,1-.22-.1.3.3,0,0,1,0-.43c5.4-5,7.83-6.05,7.93-6.09a.3.3,0,0,1,.23.56s-2.46,1.07-7.75,6A.34.34,0,0,1,439.88,266.88Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05,270.57s-.32,1.23-.92,1.43l-.61.21,1,1.2-3.72-1.06s1.51,2.27,2.21,2.57,1.31-.1.71.3-5-.08-5-.08a5.8,5.8,0,0,0,4.43,2.9s7.24,11.46,13.07,11.76,12.27-3.72,13.88-8.54-9.25-17.9-13.67-18.51S413.05,270.57,413.05,270.57Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.33,251.66a33.07,33.07,0,0,1-5.95-3c-3.67-2.23-11.72-2.23-11.72-2.23a87.73,87.73,0,0,0,10.06,5.63A19.66,19.66,0,0,0,419,253.3Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.86,264.58a32.27,32.27,0,0,1-3.65-5.55c-2.06-3.77-9-7.81-9-7.81a88.32,88.32,0,0,0,5.87,9.92,19.53,19.53,0,0,0,6.52,5.18Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.19,258.76a33,33,0,0,1,3.81-5.45c2.73-3.31,3.9-11.27,3.9-11.27a90.15,90.15,0,0,0-7,9.13,19.59,19.59,0,0,0-2.39,8Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.37,269.48a32.91,32.91,0,0,1,6.38,1.86c4,1.53,11.92.1,11.92.1a88.21,88.21,0,0,0-10.9-3.75,19.57,19.57,0,0,0-8.32.29Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,266.48a32.89,32.89,0,0,1,4.78-4.62c3.32-2.72,6-10.31,6-10.31a89,89,0,0,0-8.65,7.61,19.61,19.61,0,0,0-3.88,7.38Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.24,268.73c-.05,0-1.33-1.08-3.21-2.7l-4.17,2.26c-2.25,1.22-3.42,1.59-1.05-1.15-2.25,1.22-3.42,1.59-1.05-1.15,1.82-2.1,3.5-2,4.18-1.78l-1.59-1.4.78.84-4.24,2.3c-2.26,1.22-3.43,1.6-1.05-1.14s4.5-1.67,4.5-1.67l0-.39-1.36-1.23.46.5-4.24,2.3c-2.26,1.22-3.43,1.6-1-1.14s4.5-1.67,4.5-1.67l0-.33-1-.95.38.46s-6.85,2.25-5.65.66a3.24,3.24,0,0,1,1.87-1.05c-1.71.42-3.44.69-2.79-.17.95-1.27,3.62-1.35,4.68-1.33l-.85-.83-2.13.55c-1.5.39-2.76.12-1.64-.66a5.85,5.85,0,0,1,3.2-.45l-.52-.5a7.36,7.36,0,0,0-1.08.26c-.74.23-4,.2-2.86-.85.95-.87,2.57-.39,3.23-.13l-.56-.58c-.33,0-1,0-1.41,0a2.46,2.46,0,0,1-1.78-.59c-.28-.36.77-.32.77-.32a4,4,0,0,1-.93-.45c-.41-.29.67-.36.67-.36a2.74,2.74,0,0,1-.9-.71,12,12,0,0,1-.84-3c0-.6.26-.15.54.21a19.06,19.06,0,0,1,1.75,2,7.17,7.17,0,0,1,.74,1.25l.65.72a1.2,1.2,0,0,1,.94,0c.58.28,1.09,1.55,1.27,1.71s.43-1.26,1.14-.27a4.42,4.42,0,0,1,.51,1,4.85,4.85,0,0,1-.09-.57c-.23-1.68-.08-3.3,1.07-1.18.1.19.19.38.28.59.08-.74.41-.9,1.14.45a8,8,0,0,1,.38.83c-.53-2.59-.93-3.79.46-1.81s2.08,7.05,2.24,8.22l.72.64a28.4,28.4,0,0,1-1.44-5c-.57-2.95-1.13-4.45.36-2.34,1.35,1.92,2.12,7.35,2.25,8.32l.73.63a29.35,29.35,0,0,1-1.51-5.12c-.57-2.95-1.12-4.45.36-2.34s2.19,7.82,2.26,8.42l2.3,1.92Zm-5-3.47a2.63,2.63,0,0,1,1.05.21v-.07l-.5-.43C413.68,265.05,413.5,265.14,413.27,265.26Zm-8.06-5a11.69,11.69,0,0,1,3.1-.24l-.53-.5C407.36,259.67,406.3,260,405.21,260.27Zm2.24-1.47h0l0,0Zm3,1.38c.11.75.15,1.35.17,1.59l.54.48C411,261.8,410.75,261.08,410.48,260.18Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.4,284.53c-.06,0-1.59-.64-3.91-1.53v-4.74c0-2.56-.22-3.77-1.5-.37,0-2.57-.23-3.77-1.51-.38-1,2.6-.06,4,.42,4.52l-2-.73,1.11.28v-4.82c0-2.57-.22-3.78-1.5-.38s.68,4.75.68,4.75l-.37.14-1.73-.61.66.17V276c0-2.56-.22-3.77-1.51-.38s.68,4.76.68,4.76l-.3.12-1.34-.46.59.11s-1.29-7.09-2.11-5.28a3.31,3.31,0,0,0,0,2.14c-.44-1.7-1-3.35-1.47-2.37-.66,1.44.53,3.83,1.05,4.75l-1.12-.36c-.1-.38-.28-1.11-.54-2.12-.37-1.51-1.2-2.49-1.35-1.14a5.7,5.7,0,0,0,1.12,3l-.69-.21a8.63,8.63,0,0,1-.28-1.08c-.15-.75-1.74-3.62-2.11-2.11-.32,1.25.87,2.45,1.42,2.91l-.77-.22c-.16-.29-.49-.87-.65-1.26a2.48,2.48,0,0,0-1.36-1.28c-.45-.08.07.83.07.83a3.53,3.53,0,0,0-.83-.61c-.45-.22,0,.76,0,.76a2.87,2.87,0,0,0-1.05-.45,11.71,11.71,0,0,0-3,.68c-.52.3,0,.3.44.37a19.76,19.76,0,0,0,2.57.61,7.66,7.66,0,0,0,1.44.05l.95.23a1.25,1.25,0,0,0,.4.85c.53.37,1.88.22,2.11.3s-.91,1,.3,1.13a4.52,4.52,0,0,0,1.15,0l-.55.19c-1.58.6-2.94,1.51-.52,1.51a4.68,4.68,0,0,0,.64,0c-.6.43-.59.79.94.79a7.19,7.19,0,0,0,.91-.06c-2.52.77-3.77,1-1.36,1.27s7.18-1.53,8.29-1.95l.9.33a28.94,28.94,0,0,0-5,1.09c-2.87.91-4.45,1.13-1.89,1.43,2.33.28,7.47-1.63,8.38-2l.91.35a28.19,28.19,0,0,0-5.22,1.11c-2.86.9-4.45,1.13-1.88,1.43s7.91-1.8,8.47-2c1.68.65,2.74,1.09,2.78,1.1ZM400,281.82a2.65,2.65,0,0,0,.67.82l-.06,0-.61-.23Zm-8.23-4.71A11.62,11.62,0,0,0,393,280l-.69-.23C392.25,279.29,392,278.2,391.76,277.11Zm-.23,2.67h0Zm2.65,2c.71-.27,1.26-.51,1.48-.61l.68.24C395.86,281.48,395.1,281.59,394.18,281.79Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.63,282s1.33,1.07,3.24,2.66l4.13-2.31c2.24-1.25,3.41-1.64,1.07,1.14,2.24-1.25,3.4-1.65,1.06,1.13-1.79,2.12-3.46,2-4.15,1.83.52.44,1,.91,1.6,1.39l-.78-.84,4.21-2.35c2.24-1.25,3.41-1.64,1.07,1.13s-4.48,1.72-4.48,1.72l0,.39,1.38,1.22-.47-.5,4.21-2.36c2.24-1.25,3.41-1.64,1.07,1.14s-4.48,1.72-4.48,1.72l0,.33,1.05.94-.38-.46s6.82-2.33,5.64-.73a3.35,3.35,0,0,1-1.86,1.08c1.71-.45,3.43-.74,2.79.13-.93,1.27-3.6,1.39-4.66,1.39l.87.81,2.11-.57c1.5-.41,2.76-.16,1.65.63a5.65,5.65,0,0,1-3.19.49l.52.51c.13,0,.5-.1,1.08-.28.74-.24,4-.25,2.88.81-.94.88-2.57.43-3.24.18l.57.56c.33,0,1,0,1.42,0a2.48,2.48,0,0,1,1.78.56c.28.36-.76.34-.76.34a3.5,3.5,0,0,1,.93.43c.41.28-.66.37-.66.37a2.89,2.89,0,0,1,.91.7,12.16,12.16,0,0,1,.87,3c0,.6-.25.15-.54-.21a19.29,19.29,0,0,1-1.78-1.94,7.83,7.83,0,0,1-.75-1.24l-.67-.71a1.26,1.26,0,0,1-.93.06c-.59-.28-1.12-1.53-1.29-1.7s-.42,1.27-1.14.29a4.63,4.63,0,0,1-.52-1c0,.19.07.38.1.57.24,1.68.11,3.3-1.06,1.2-.1-.19-.2-.38-.29-.58-.07.73-.39.9-1.14-.44a7,7,0,0,1-.39-.83c.56,2.58,1,3.78-.45,1.81s-2.16-7-2.34-8.19l-.73-.62a27.74,27.74,0,0,1,1.51,4.93c.61,2.95,1.19,4.44-.33,2.35-1.37-1.9-2.21-7.32-2.35-8.28l-.75-.63a29.09,29.09,0,0,1,1.58,5.1c.6,2.94,1.18,4.43-.33,2.34s-2.29-7.79-2.37-8.38c-1.39-1.15-2.28-1.86-2.32-1.89Zm5,3.4a2.63,2.63,0,0,1-1-.19v.07l.5.42Zm8.13,4.89a12,12,0,0,1-3.1.29l.54.48C456.62,291,457.67,290.61,458.76,290.32Zm-2.22,1.5h0l0,0Zm-3-1.33c-.12-.76-.18-1.35-.2-1.59l-.54-.48C452.94,288.87,453.21,289.59,453.5,290.49Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,295.53a12.44,12.44,0,0,0-.81-1.17l-.66.57a6.48,6.48,0,0,1,1-1.11.17.17,0,0,0,0-.23.17.17,0,0,0-.24,0,2.16,2.16,0,0,0-.37.32l.14-.19s-1-1.3-1.8-1.17-.84.86-.23,1.35a3.66,3.66,0,0,0,1.31.65c-.15.18-.31.39-.5.64a1.52,1.52,0,0,0-1.52-.66c-1.13.14-.75.64-.38.91a2.54,2.54,0,0,0,1.37.31l.12,0-.65.93a2.85,2.85,0,0,0-2-.73c-1,.18-.38,1.27.23,1.4a3.57,3.57,0,0,0,1.43-.15l-.52.8a2.91,2.91,0,0,0-2-.74c-1,.18-.38,1.26.24,1.4a3.63,3.63,0,0,0,1.5-.17l-.52.85a2.06,2.06,0,0,0-1.47-.51c-.77.13-.28.93.17,1a2.62,2.62,0,0,0,1.05-.1c-.08.12-.15.25-.23.38-.32,0-1.81-.17-1.73.28s.85.45.85.45-1.42.45-1.09.72a2,2,0,0,0,.71.36.63.63,0,0,0-.52.54c-.09.5-.54,1.33-.17,1.46l.08,0a.19.19,0,0,0,.15-.09h0a4.3,4.3,0,0,0,.79-1.15s0,.63.33.22a2.8,2.8,0,0,0,.47-.86s.14.77.43.28a2.05,2.05,0,0,0,.28-.91s.24.68.42.14a3.34,3.34,0,0,0-.28-1.67l-.06-.21.34-.56c0,.23-.19,1.63.29,1.67s.56-.76.52-1.31a5,5,0,0,0-.32-1.15c.09-.15.18-.28.26-.42,0,.53.09,1.43.53,1.53.61.13.94,0,.61-1.08a12.6,12.6,0,0,0-.5-1.41l.66-.95a2.67,2.67,0,0,0,.08,1.77c.42.86,1,.59,1-.27a4.5,4.5,0,0,0-.8-1.87c.09-.12.17-.23.26-.33.07.45.44,2.39,1.4,2.11S408.06,296.16,407.69,295.53Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57,297.64a12.26,12.26,0,0,0-1.27-.64l-.3.82a6.6,6.6,0,0,1,.37-1.47.16.16,0,0,0-.07-.22.18.18,0,0,0-.24.07,3.07,3.07,0,0,0-.16.47l0-.23s-1.5-.68-2.14-.17-.33,1.16.45,1.3a3.94,3.94,0,0,0,1.46-.06c0,.23-.09.49-.14.8a1.48,1.48,0,0,0-1.64.15c-.93.66-.36.92.1,1a2.51,2.51,0,0,0,1.35-.38l.1-.07c0,.33-.09.7-.13,1.12a2.84,2.84,0,0,0-2.11.33c-.83.66.27,1.29.87,1.12a3.51,3.51,0,0,0,1.19-.82c0,.3-.05.62-.07.95a2.91,2.91,0,0,0-2.15.33c-.83.66.27,1.29.88,1.11a3.66,3.66,0,0,0,1.23-.86c0,.31,0,.65-.05,1a2,2,0,0,0-1.53.26c-.61.48.2.95.65.82a2.63,2.63,0,0,0,.86-.59c0,.14,0,.29,0,.44-.3.13-1.67.73-1.39,1.08s1,0,1,0-1,1.08-.61,1.16a1.86,1.86,0,0,0,.79,0,.64.64,0,0,0-.19.73c.15.48.17,1.42.54,1.36l.08,0a.18.18,0,0,0,.1-.16h0a4.4,4.4,0,0,0,.13-1.39s.3.55.4,0a3,3,0,0,0,0-1s.49.6.5,0a2,2,0,0,0-.18-.92s.53.48.44-.09-1.05-1.33-1.05-1.33l-.16-.16,0-.65c.09.22.62,1.52,1.06,1.33s.12-.94-.18-1.39a4.9,4.9,0,0,0-.83-.87l0-.49c.26.46.77,1.21,1.2,1.09.6-.17.84-.41,0-1.24a10.12,10.12,0,0,0-1.11-1c0-.43.08-.81.12-1.16a2.69,2.69,0,0,0,.92,1.52c.78.55,1.19,0,.74-.71a4.44,4.44,0,0,0-1.6-1.26c0-.15,0-.29.07-.42.28.37,1.53,1.89,2.24,1.18S415.2,298,414.57,297.64Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,244.56s-1.43-2.46-2.81-2.58-1.42,1.55-1.14,2.23.4,1,.4,1-1.77-1.26-3.31-.51-.63,1.65.11,2.68a11.69,11.69,0,0,0,1.6,1.78s-3.37-1.55-4.34-.86,2.63,2.11,2.63,2.11-2.75.23-1.83.8a4.79,4.79,0,0,0,1.77.69s-3.26.23-1.66,1.37,5.83.92,5.83.92-2.51,2.17-2,3,3.26-.8,3.26-.8-.63,2.8,1,2.28,2.69-3,2.69-3,1.08,4.4,2.17,3.32a3.78,3.78,0,0,0,.8-2.92s4.68,3,4.91,1.55-1.6-3.95-1.6-3.95,4.23-.28,4.23-1a2.15,2.15,0,0,0-.74-1.37s1-.51.91-.91-.91-.86-.91-.86.74-.4.46-.92a1.93,1.93,0,0,0-.86-.74s.86-1.14.23-1.6a1.93,1.93,0,0,0-1-.46s.63-1,.17-1.6-2-.11-2-.11.46-1.2-.4-1.32a4.14,4.14,0,0,0-2,.52s.46-1.6-.45-1.72-1.95,1.26-1.95,1.26-.4-2.11-1.14-2.17a1.58,1.58,0,0,0-1,.11S421.75,239.35,421.7,244.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.74,259.44l-.18,0c-.78-.22-1.4-2-1.7-3a5.13,5.13,0,0,1-2.55,2.55,1,1,0,0,1-1.06-.16,2.35,2.35,0,0,1-.37-1.89,5,5,0,0,1-2.67.79.72.72,0,0,1-.47-.34c-.47-.77.77-2.14,1.55-2.89-1.3,0-4-.07-5.31-1-.44-.31-.62-.62-.53-.92s.64-.6,1.18-.73a6.12,6.12,0,0,1-.76-.39c-.3-.19-.32-.39-.29-.53s.51-.49,1.31-.62c-.89-.42-2-1.06-2.09-1.64a.56.56,0,0,1,.26-.55c.7-.49,2.32,0,3.44.37a11.2,11.2,0,0,1-.75-.93l-.22-.3c-.47-.62-.9-1.2-.76-1.8a1.6,1.6,0,0,1,1-1,3.46,3.46,0,0,1,2.94.18c0-.11-.09-.23-.15-.37a2.32,2.32,0,0,1,.18-2.06,1.29,1.29,0,0,1,1.22-.52c1,.09,2,1.26,2.55,2,.11-1.8.52-2.9,1.23-3.27a1.28,1.28,0,0,1,1.18,0,2.35,2.35,0,0,1,1-.08c.67.05,1.07,1.17,1.26,1.88a2.42,2.42,0,0,1,1.84-1,.82.82,0,0,1,.59.37,1.73,1.73,0,0,1,.17,1.16,3.59,3.59,0,0,1,1.7-.32.81.81,0,0,1,.61.37,1.31,1.31,0,0,1,.1.84c.53-.1,1.4-.18,1.79.31a1.56,1.56,0,0,1,0,1.59,3.18,3.18,0,0,1,.76.42.84.84,0,0,1,.32.53,2,2,0,0,1-.34,1.18,2,2,0,0,1,.72.71.76.76,0,0,1,.06.57,1,1,0,0,1-.3.45,1.83,1.83,0,0,1,.71.81c.12.42-.37.81-.74,1a2.13,2.13,0,0,1,.58,1.31c0,.75-2.09,1.09-4,1.25.51.76,1.58,2.53,1.39,3.76a.67.67,0,0,1-.4.54c-.92.42-3.39-1-4.48-1.64a3.6,3.6,0,0,1-.91,2.61A.74.74,0,0,1,425.74,259.44Zm-1.82-4h0a.27.27,0,0,1,.23.19c.31,1.28,1,3.15,1.53,3.29,0,0,.1,0,.22-.09a3.53,3.53,0,0,0,.73-2.7.27.27,0,0,1,.11-.25.26.26,0,0,1,.27,0c1.37.88,3.78,2.17,4.43,1.88a.2.2,0,0,0,.11-.16c.21-1.37-1.54-3.74-1.56-3.76a.25.25,0,0,1,0-.25.23.23,0,0,1,.21-.15c2-.13,3.85-.5,4-.79a2,2,0,0,0-.66-1.17.24.24,0,0,1-.09-.22.25.25,0,0,1,.14-.19c.43-.22.78-.52.78-.63s-.51-.54-.79-.7a.26.26,0,0,1-.13-.22.25.25,0,0,1,.13-.22c.08-.05.33-.22.38-.4a.21.21,0,0,0,0-.17,1.7,1.7,0,0,0-.73-.64.24.24,0,0,1-.15-.16.24.24,0,0,1,0-.22,1.81,1.81,0,0,0,.4-1,.28.28,0,0,0-.12-.21,1.84,1.84,0,0,0-.83-.41.23.23,0,0,1-.21-.13.28.28,0,0,1,0-.25c.15-.24.48-1,.19-1.31s-1.24-.16-1.67,0a.25.25,0,0,1-.26-.07.27.27,0,0,1-.05-.26,1.25,1.25,0,0,0,.05-.84.3.3,0,0,0-.25-.14,3.7,3.7,0,0,0-1.85.49.25.25,0,0,1-.27,0,.25.25,0,0,1-.09-.26,2,2,0,0,0,0-1.26.35.35,0,0,0-.24-.14c-.64-.08-1.46.81-1.72,1.16a.23.23,0,0,1-.25.09.25.25,0,0,1-.19-.19c-.18-.93-.59-1.95-.92-2a1.52,1.52,0,0,0-.81.07.24.24,0,0,1-.28,0,.86.86,0,0,0-.8-.06c-.35.19-.95.92-1,3.63a.27.27,0,0,1-.19.24.25.25,0,0,1-.28-.12c-.38-.65-1.59-2.36-2.61-2.45a.8.8,0,0,0-.77.31,1.89,1.89,0,0,0-.12,1.58c.29.69.41,1,.41,1a.25.25,0,0,1-.09.28.24.24,0,0,1-.29,0s-1.68-1.16-3.07-.5c-.4.2-.63.4-.68.63s.28.86.67,1.38l.22.31a12.65,12.65,0,0,0,1.56,1.73.24.24,0,0,1,.05.32.25.25,0,0,1-.31.09c-1.26-.57-3.48-1.32-4.1-.88-.06.05-.06.07-.06.08,0,.35,1.4,1.11,2.64,1.6a.25.25,0,0,1-.07.48,6.22,6.22,0,0,0-1.73.34h0a4.54,4.54,0,0,0,1.67.65.25.25,0,0,1,0,.5c-.92.06-1.81.32-1.87.53,0,0,0,.18.34.39,1.51,1.08,5.63.87,5.67.87a.24.24,0,0,1,.24.15.26.26,0,0,1-.06.29c-1.14,1-2.2,2.29-1.95,2.71a.21.21,0,0,0,.16.1,5.73,5.73,0,0,0,2.75-1,.26.26,0,0,1,.28,0,.24.24,0,0,1,.09.26c-.13.58-.21,1.63.14,1.95,0,0,.18.16.57,0,1.53-.47,2.52-2.86,2.53-2.88A.25.25,0,0,1,423.92,255.45ZM413.06,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.87,251.1c0,1.69-1.77,3.06-3.94,3.06S420,252.79,420,251.1s1.77-3.06,3.95-3.06S427.87,249.41,427.87,251.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.92,254.41c-2.31,0-4.19-1.49-4.19-3.31s1.88-3.31,4.19-3.31,4.2,1.49,4.2,3.31S426.24,254.41,423.92,254.41Zm0-6.12c-2,0-3.69,1.26-3.69,2.81s1.66,2.81,3.69,2.81,3.7-1.26,3.7-2.81S426,248.29,423.92,248.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.76,245.09c0-.15,0-.31,0-.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.76,245.34h0a.25.25,0,0,1-.23-.27c0-.15,0-.3,0-.45a.27.27,0,0,1,.25-.24.26.26,0,0,1,.25.26c0,.15,0,.31,0,.46A.26.26,0,0,1,425.76,245.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.31,248.23a20.88,20.88,0,0,0,.4-2.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.31,248.48h-.05a.25.25,0,0,1-.19-.3,22.83,22.83,0,0,0,.39-2.53.26.26,0,0,1,.28-.23.25.25,0,0,1,.22.27,21.76,21.76,0,0,1-.4,2.61A.26.26,0,0,1,425.31,248.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.35,
    y1: 248.17,
    x2: 421.6,
    y2: 245.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.35,248.42a.25.25,0,0,1-.24-.18l-.75-2.55a.25.25,0,0,1,.48-.14l.75,2.55a.24.24,0,0,1-.17.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.61,
    y1: 247.74,
    x2: 419.29,
    y2: 247.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.61,248a.25.25,0,0,1-.19-.09l-.32-.37a.25.25,0,0,1,.38-.33l.32.37a.25.25,0,0,1,0,.35A.23.23,0,0,1,419.61,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.78,
    y1: 249.08,
    x2: 419.93,
    y2: 248.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.78,249.33a.25.25,0,0,1-.19-.09l-.85-1a.25.25,0,0,1,0-.35.26.26,0,0,1,.36,0l.84,1a.26.26,0,0,1,0,.36A.27.27,0,0,1,420.78,249.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.93,254.16a3.84,3.84,0,0,0-.18.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,255.21h0a.25.25,0,0,1-.21-.28,4.35,4.35,0,0,1,.19-.85.25.25,0,0,1,.32-.16.25.25,0,0,1,.15.32,4.58,4.58,0,0,0-.17.75A.24.24,0,0,1,423.75,255.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.89,
    y1: 251.94,
    x2: 417.65,
    y2: 251.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.65,252.19a.25.25,0,0,1-.25-.24.26.26,0,0,1,.25-.26h.23a.25.25,0,0,1,.26.24.26.26,0,0,1-.25.26h-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.91,
    y1: 251.89,
    x2: 418.27,
    y2: 251.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.27,252.18a.25.25,0,0,1-.25-.24.24.24,0,0,1,.24-.26l1.65,0h0a.25.25,0,0,1,.25.24.26.26,0,0,1-.25.26l-1.65,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.6,250.38a3.59,3.59,0,0,1,.57.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.17,250.74h-.06l-.55-.11a.24.24,0,0,1-.21-.28.25.25,0,0,1,.28-.21,6,6,0,0,1,.61.12.27.27,0,0,1,.18.31A.25.25,0,0,1,431.17,250.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,250.49a9.72,9.72,0,0,1,2.35-.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,250.74a.25.25,0,0,1-.05-.49,9.8,9.8,0,0,1,2.42-.17.25.25,0,1,1,0,.5,9.31,9.31,0,0,0-2.28.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.88,249a17.57,17.57,0,0,1,2.84-1.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.88,249.23a.25.25,0,0,1-.21-.1.26.26,0,0,1,.07-.35,17.48,17.48,0,0,1,2.9-1.66.26.26,0,0,1,.32.15.24.24,0,0,1-.15.32,17.22,17.22,0,0,0-2.79,1.6A.23.23,0,0,1,426.88,249.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.61,
    y1: 255.02,
    x2: 421.71,
    y2: 253.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.61,255.27a.27.27,0,0,1-.15-.05.24.24,0,0,1,0-.35l1.1-1.4a.25.25,0,0,1,.35,0,.24.24,0,0,1,0,.35l-1.1,1.4A.27.27,0,0,1,420.61,255.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.18,
    y1: 253.8,
    x2: 426.65,
    y2: 254.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.65,254.92a.23.23,0,0,1-.22-.13l-.47-.87a.26.26,0,0,1,.1-.34.25.25,0,0,1,.34.1l.47.87a.25.25,0,0,1-.1.34A.27.27,0,0,1,426.65,254.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.2,
    y1: 252.76,
    x2: 427.58,
    y2: 252.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2,253h-.07l-1.62-.47a.24.24,0,0,1-.17-.31.24.24,0,0,1,.3-.17l1.63.47a.25.25,0,0,1-.07.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.93,264.94s1.93-1.81,1.06-1.83a3.32,3.32,0,0,0-1.71.54s.57-2.35-.21-2.18a4.76,4.76,0,0,0-1.77,1.37s.26-2-.6-1.44-1,.9-1,.9-.25-2.53-1-2.13a.92.92,0,0,0-.58,1s-.4-1-.71-.59,0,1.4,0,1.4-1.29-1.74-1.63-1.15a1.54,1.54,0,0,0,0,1.3s-.58-.47-.64-.07.49,1.06.49,1.06-1.41-.52-1.53.15,1.16,2,1.16,2-3.38-1.33-3.3-.5a1.82,1.82,0,0,0,.71,1.26s-.72-.22-.41.19a2.7,2.7,0,0,0,1.16.64s-2.39-.38-2.71.51,2.79,1,2.79,1-1.91,1.06-1,1.34,4-.86,4-.86-3.26,2-2.56,2.72,3.62-1.74,3.62-1.74,1.05,2.41,1.83,2.23.53-2.45.53-2.45,1.92,3.1,3.4,3.09-.53-3.13-.72-3.41,2.13-.56,3.25-1.2,0-1.17,0-1.17,1.95-1,1.18-1.16a7.27,7.27,0,0,0-2.24.05s1.5-1,.71-1.25A1.81,1.81,0,0,0,420.93,264.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.27,272.93c-1.13,0-2.4-1.5-3.1-2.46,0,.75-.15,1.68-.76,1.82-.78.17-1.61-1.29-2-2.08-.92.75-3,2.26-3.71,1.52a.62.62,0,0,1-.16-.51c.06-.49.71-1.11,1.37-1.63a5.94,5.94,0,0,1-2.52.33.51.51,0,0,1-.4-.41c0-.32.33-.67.73-1-.78-.07-1.86-.26-2.17-.73a.56.56,0,0,1-.07-.53c.22-.59,1-.75,1.73-.77a1,1,0,0,1-.14-.15.41.41,0,0,1-.07-.5.39.39,0,0,1,.1-.08,2,2,0,0,1-.38-1,.43.43,0,0,1,.18-.41c.4-.31,1.61,0,2.56.32a2.31,2.31,0,0,1-.6-1.46.6.6,0,0,1,.31-.43,1.43,1.43,0,0,1,.9-.09,1.11,1.11,0,0,1-.17-.69.39.39,0,0,1,.25-.34.39.39,0,0,1,.26,0,1.57,1.57,0,0,1,.18-1,.49.49,0,0,1,.39-.24,1.86,1.86,0,0,1,1.05.64,1,1,0,0,1,.19-.68.43.43,0,0,1,.41-.18.63.63,0,0,1,.37.24,1.38,1.38,0,0,1,.58-.53.53.53,0,0,1,.52,0c.43.23.65,1.11.75,1.75a5.22,5.22,0,0,1,.7-.5.59.59,0,0,1,.67,0,1.27,1.27,0,0,1,.35,1,3.44,3.44,0,0,1,1.42-.93.53.53,0,0,1,.49.13c.32.33.24,1.2.13,1.81a3.15,3.15,0,0,1,1.37-.31.43.43,0,0,1,.44.26c.1.27-.14.69-.49,1.12a1.72,1.72,0,0,1,.59.06c.32.1.39.3.4.41a1,1,0,0,1-.35.73,5.16,5.16,0,0,1,1.48.05c.29.08.35.26.36.36,0,.29-.35.66-1.13,1.08a.81.81,0,0,1,.26.53c0,.3-.2.58-.63.83a9.92,9.92,0,0,1-2.19.76c-.31.08-.67.18-.86.25.37.58,1.5,2.48,1.09,3.27a.73.73,0,0,1-.69.36Zm-3.76-4.41.58.94c.51.82,2.09,3,3.18,3h0c.2,0,.24-.07.25-.1.24-.45-.62-2.12-1.17-2.92l-.07-.11,0-.17c.09-.23.38-.32,1.3-.56a9.42,9.42,0,0,0,2.08-.72c.23-.13.37-.27.37-.38s-.23-.29-.35-.35l-.46-.22.46-.23a5.32,5.32,0,0,0,1.14-.71,7.68,7.68,0,0,0-2.05.08l-1.16.2,1-.66a2.51,2.51,0,0,0,.83-.78l-.06,0a1.58,1.58,0,0,0-1.29.35l-.34-.37a6.17,6.17,0,0,0,1.19-1.4,3,3,0,0,0-1.53.5l-.54.36.15-.63a3.47,3.47,0,0,0,.11-1.88A4.35,4.35,0,0,0,418.5,263l-.56.67.12-.86a2.07,2.07,0,0,0-.1-1.25s0,0-.13.06a2.3,2.3,0,0,0-.9.77l-.38.86-.1-.93a3.71,3.71,0,0,0-.57-1.94c-.58.3-.51.69-.5.74l-.48.15a1.83,1.83,0,0,0-.29-.5,2,2,0,0,0,.09,1.13l.51,1.49-.95-1.26c-.46-.62-1-1.17-1.23-1.17h0a1.33,1.33,0,0,0,0,1.06l.43,1-.81-.65-.24-.15a2,2,0,0,0,.43.79l.59.71-.87-.32a1.94,1.94,0,0,0-1.13-.12.09.09,0,0,0-.06.09c-.07.37.6,1.25,1.09,1.76l.81.83-1.08-.42a7,7,0,0,0-3-.72,1.66,1.66,0,0,0,.62,1.05l1.26.9-1.24-.39a2.49,2.49,0,0,0,.65.27l-.1.49c-.91-.14-2.26-.12-2.44.36,0,0,0,.06,0,.08.23.34,1.66.54,2.55.57l.9,0-.78.44a3.93,3.93,0,0,0-1.13.87l0,0c.57.18,2.64-.43,3.81-.85l2.32-.85-2.1,1.3c-1,.62-2.47,1.72-2.53,2.23a.11.11,0,0,0,0,.1c.32.33,2-.64,3.28-1.76l.26-.21.13.3c.45,1,1.16,2.09,1.51,2.09h0c.36-.09.42-1.32.33-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.23,268.53a1.66,1.66,0,1,1,1.06-2.3A1.79,1.79,0,0,1,416.23,268.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.32,269a2.26,2.26,0,0,1-.74-.13,1.75,1.75,0,0,1-1-.91,1.79,1.79,0,0,1,0-1.5,2.36,2.36,0,0,1,1.16-1.13,2,2,0,0,1,2.77.81,1.79,1.79,0,0,1,0,1.5,2.3,2.3,0,0,1-1.15,1.13A2.48,2.48,0,0,1,415.32,269Zm.45-3.4a2,2,0,0,0-.81.18,1.83,1.83,0,0,0-.91.89,1.22,1.22,0,0,0,.7,1.73,1.85,1.85,0,0,0,1.38-.09h0a1.82,1.82,0,0,0,.91-.88,1.24,1.24,0,0,0,0-1.08A1.38,1.38,0,0,0,415.77,265.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,266.05a.25.25,0,0,1-.16-.06.25.25,0,0,1,0-.35l1.09-1.36a.25.25,0,0,1,.39.31L417.16,266A.26.26,0,0,1,417,266.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3,264.32h-.05a.24.24,0,0,1-.19-.29l.05-.26a.24.24,0,0,1,.29-.2.25.25,0,0,1,.2.3l-.05.26A.26.26,0,0,1,416.3,264.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.06,265.54H416a.26.26,0,0,1-.2-.29l.17-.84a.25.25,0,0,1,.49.1l-.17.83A.24.24,0,0,1,416.06,265.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.76,266.55l-.1,0-.84-.35a.26.26,0,0,1-.13-.33.24.24,0,0,1,.33-.13l.83.35a.25.25,0,0,1-.09.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.34,268.48a.23.23,0,0,1-.14,0l-1.08-.73a.25.25,0,0,1-.06-.35.24.24,0,0,1,.34-.06l1.08.73a.26.26,0,0,1,.07.35A.25.25,0,0,1,418.34,268.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,266a.25.25,0,0,1-.09-.48l.37-.13a.25.25,0,1,1,.17.47l-.37.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,266.71a.25.25,0,0,1-.24-.17.25.25,0,0,1,.15-.32l1.21-.43a.25.25,0,0,1,.32.15.24.24,0,0,1-.15.32l-1.21.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.31,267.59h0l-.43,0a.26.26,0,0,1-.22-.28.26.26,0,0,1,.28-.22l.43,0a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.57,267.74h0l-.76-.09a.25.25,0,0,1,.06-.5l.76.09a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.86,269.51a.25.25,0,0,1-.24-.21l-.09-.45a.25.25,0,0,1,.2-.29.24.24,0,0,1,.29.2l.09.45a.24.24,0,0,1-.2.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,265.79a.25.25,0,0,1-.22-.13l-.54-1.11a.25.25,0,0,1,.11-.33.26.26,0,0,1,.34.11l.54,1.1a.25.25,0,0,1-.12.34A.2.2,0,0,1,414.85,265.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.67,293.55a28.81,28.81,0,0,0-5.72,9.24c-2.18,5.71-2.18,11-2.9,12.67s-1.46,2-1.46,2,4.68-.52,6.86-2.71,3.84-6.23,5.92-11.21a23.23,23.23,0,0,1,5.81-8.1Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,298.52a.45.45,0,1,0,.45.45A.45.45,0,0,0,416.65,298.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,301.64a.45.45,0,0,0-.45.45.45.45,0,0,0,.9,0A.45.45,0,0,0,416.65,301.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,307.86a.45.45,0,1,0,.45.45A.45.45,0,0,0,416.65,307.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,304.75a.45.45,0,1,0,.45.45A.45.45,0,0,0,416.65,304.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,296.93a.45.45,0,0,0-.45.45.45.45,0,1,0,.9,0A.45.45,0,0,0,417.84,296.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,295.41a.45.45,0,1,0,.45.45A.45.45,0,0,0,416.65,295.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.85,
    cy: 300.49,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,309.38a.45.45,0,0,0-.45.45.45.45,0,1,0,.9,0A.45.45,0,0,0,414.85,309.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.85,
    cy: 303.6,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,306.26a.45.45,0,1,0,.45.45A.45.45,0,0,0,414.85,306.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,297.83A.45.45,0,0,0,415,297c-.16.23-.31.47-.47.73A.45.45,0,0,0,414.85,297.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.67,
    cy: 297.38,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.48,
    cy: 298.97,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.67,
    cy: 300.49,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,309.83a.51.51,0,0,0,.09.27c.12-.24.24-.48.35-.72A.45.45,0,0,0,417.39,309.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21,303.6a.41.41,0,0,0,.05.19l.11-.27c.05-.12.09-.23.14-.34A.46.46,0,0,0,420.21,303.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,303.15a.45.45,0,1,0,.45.45A.45.45,0,0,0,417.84,303.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,300a.45.45,0,1,0,.45.45A.45.45,0,0,0,417.84,300Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,306.26a.45.45,0,1,0,.45.45A.45.45,0,0,0,417.84,306.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.48,
    cy: 295.86,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,294.26a.45.45,0,1,0,.45-.45A.45.45,0,0,0,417.39,294.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.48,
    cy: 302.09,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.25,
    cy: 314.41,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,311a.45.45,0,0,0-.1.89c.14-.24.28-.5.42-.76A.44.44,0,0,0,416.65,311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.85,
    cy: 313.27,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.48,304.75a.45.45,0,0,0,0,.9l.32-.77A.46.46,0,0,0,419.48,304.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.67,316.21a.46.46,0,0,0,.41.25.45.45,0,0,0,0-.9H409C408.89,315.81,408.78,316,408.67,316.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.26,
    cy: 314.41,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.52,316a.46.46,0,0,0-.91,0,.49.49,0,0,0,.18.36l.72-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47,298.52a.45.45,0,0,0,0,.9.46.46,0,0,0,.21-.05c.08-.11.15-.22.23-.32s0-.05,0-.08A.45.45,0,0,0,422.47,298.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.46,295.41a.45.45,0,0,0-.45.45.46.46,0,0,0,.26.41l.6-.58A.44.44,0,0,0,425.46,295.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21,294.26a.46.46,0,0,0,.46.45.45.45,0,0,0,.44-.41l-.87-.19A.8.8,0,0,0,420.21,294.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.47,
    cy: 295.86,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.65,296.93a.45.45,0,0,0-.45.45.46.46,0,0,0,.45.45.44.44,0,0,0,.32-.13l0,0a.47.47,0,0,0,.12-.3A.46.46,0,0,0,423.65,296.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.67,
    cy: 311.42,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,299a.43.43,0,0,0-.16-.34c-.15.24-.29.5-.44.77l.15,0A.45.45,0,0,0,414.11,299Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.66,
    cy: 305.2,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.31,303.6a.45.45,0,0,0-.45-.45h0c-.09.26-.19.52-.27.77a.44.44,0,0,0,.31.13A.45.45,0,0,0,412.31,303.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.66,
    cy: 311.42,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.66,307.86a.45.45,0,1,0,.45.45A.45.45,0,0,0,413.66,307.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.66,
    cy: 302.09,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,308.76a.45.45,0,0,0,0-.9.54.54,0,0,0-.21.05c0,.23-.09.46-.14.68A.47.47,0,0,0,410.67,308.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,306.26a.45.45,0,1,0,.45.45A.45.45,0,0,0,411.86,306.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.86,
    cy: 313.27,
    r: 0.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,309.38a.45.45,0,0,0-.45.45.45.45,0,0,0,.9,0A.45.45,0,0,0,411.86,309.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,317.87l1.55-.66a3.71,3.71,0,0,0,1.33-1.85,15.51,15.51,0,0,0,.64-3.17,44.62,44.62,0,0,1,2.26-9.49,29.26,29.26,0,0,1,5.77-9.33l.1-.1,9.15,2-.4.33a23.36,23.36,0,0,0-5.74,8l-.13.31c-2.05,4.93-3.67,8.82-5.85,11s-6.81,2.75-7,2.77Zm11.81-24.05a29.17,29.17,0,0,0-5.56,9.06,43.74,43.74,0,0,0-2.23,9.38,16,16,0,0,1-.68,3.3,6.41,6.41,0,0,1-.88,1.5c1.42-.26,4.32-.95,5.87-2.5,2.1-2.1,3.71-5.95,5.74-10.83l.13-.31a23.69,23.69,0,0,1,5.52-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.46,295.1a36.74,36.74,0,0,0,3.53,8.21,119,119,0,0,0,8.2,11.22l4.47-6.44a43.17,43.17,0,0,1-5.61-8.31,59.06,59.06,0,0,1-2.7-6.44Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.61,299.21a.44.44,0,0,0,.25.15c-.11-.22-.21-.43-.3-.64A.46.46,0,0,0,435.61,299.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.39,300.63a.46.46,0,0,0-.63-.07.47.47,0,0,0-.07.64.46.46,0,0,0,.64.06A.45.45,0,0,0,436.39,300.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,307.34a.46.46,0,0,0,.07-.63.47.47,0,0,0-.64-.07.46.46,0,0,0-.06.64A.45.45,0,0,0,433.77,307.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.16,304.83a.45.45,0,1,0-.7.56.44.44,0,0,0,.63.07A.46.46,0,0,0,436.16,304.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.28,296.86a.45.45,0,1,0-.56-.7.44.44,0,0,0-.07.63A.46.46,0,0,0,434.28,296.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.37,298.84a.45.45,0,1,0-.57-.69.45.45,0,1,0,.57.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.69,305.35a.45.45,0,0,0,.06-.63.46.46,0,0,0-.63-.07.47.47,0,0,0-.07.64A.46.46,0,0,0,433.69,305.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.73,309.76a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,435.73,309.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,303.47a.45.45,0,1,0-.63-.06A.45.45,0,0,0,436,303.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.65,303.61a.45.45,0,0,0,.64.07l0,0c-.17-.24-.33-.49-.49-.74l-.1.06A.46.46,0,0,0,437.65,303.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,310.12a.45.45,0,1,0,.7-.56.44.44,0,0,0-.63-.07A.45.45,0,0,0,437,310.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,305.89a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,438,305.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,310.3a.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63A.46.46,0,0,0,440,310.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.93,308.31a.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06.46.46,0,0,0-.07.63A.47.47,0,0,0,439.93,308.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.69,312.18a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,437.69,312.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,307.71a.46.46,0,0,0,.64.06.45.45,0,0,0,.06-.63.46.46,0,0,0-.63-.07A.47.47,0,0,0,435,307.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.12,307.25a.45.45,0,1,0-.7.56.44.44,0,0,0,.63.07A.46.46,0,0,0,438.12,307.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.2,302.41a.47.47,0,0,0-.64-.07.46.46,0,0,0-.06.64.45.45,0,0,0,.7-.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.85,302.51a.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63A.46.46,0,0,0,429.85,302.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,300.09a.47.47,0,0,0,.07-.64.45.45,0,0,0-.8.28c0,.12.1.23.16.35A.44.44,0,0,0,427.89,300.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.28,297.57a.45.45,0,0,0-.63-.06.44.44,0,0,0-.07.63.46.46,0,0,0,.63.07A.45.45,0,0,0,430.28,297.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,306.6a.44.44,0,0,0-.4-.16l.45.64A.44.44,0,0,0,431.43,306.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,298.1a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,427.81,298.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88,314.05l0,0,.35.44.31-.44A.45.45,0,0,0,436.88,314.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.35,311.44a.46.46,0,0,0-.63-.07l0,0,.55.7,0,0A.44.44,0,0,0,435.35,311.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,309a.46.46,0,0,0-.57-.11l.53.72A.45.45,0,0,0,433.39,309Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,301a.45.45,0,0,0,.63.06.46.46,0,0,0,.07-.63.47.47,0,0,0-.64-.07A.46.46,0,0,0,433.42,301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.24,300a.46.46,0,0,0-.63-.07.45.45,0,1,0,.56.7A.44.44,0,0,0,432.24,300Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.81,304.92a.46.46,0,0,0,.07-.63.47.47,0,0,0-.64-.07.46.46,0,0,0-.06.64A.45.45,0,0,0,431.81,304.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.09,298.64a.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63A.46.46,0,0,0,432.09,298.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.09,302.87a.47.47,0,0,0,.64.07.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06A.46.46,0,0,0,431.09,302.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.13,300.45a.47.47,0,0,0,.64.07.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06A.46.46,0,0,0,429.13,300.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.47,295.79a.45.45,0,0,0-.63-.06.46.46,0,0,0-.07.63.47.47,0,0,0,.64.07A.46.46,0,0,0,432.47,295.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.13,296.22a.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63A.46.46,0,0,0,430.13,296.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.76,293.74a.44.44,0,0,0-.07.63.45.45,0,1,0,.7-.57.44.44,0,0,0-.38-.16l-.12,0A.46.46,0,0,0,431.76,293.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,314.94l-.21-.25a121.77,121.77,0,0,1-8.23-11.25,38,38,0,0,1-3.56-8.27l-.06-.25,8.37-1.88.07.22a59.17,59.17,0,0,0,2.69,6.41,42.5,42.5,0,0,0,5.57,8.25l.13.15Zm-11.44-19.65a37.14,37.14,0,0,0,3.43,7.89,114.1,114.1,0,0,0,8,10.93l4.16-6a43.23,43.23,0,0,1-5.51-8.21,63.11,63.11,0,0,1-2.64-6.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,296.14s-12.87-.72-13.19-2.18,3.74-10.7,6.55-11.63,8.72,2.91,8.72,2.91S425.25,295.21,425.66,296.14Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.58,286.35a.46.46,0,0,0-.63-.07.47.47,0,0,0-.07.64.46.46,0,0,0,.64.06A.45.45,0,0,0,417.58,286.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,291.18a.45.45,0,0,0,0-.53.45.45,0,0,0-.63-.06.53.53,0,0,0-.12.14.45.45,0,0,0,0,.53.45.45,0,0,0,.63.06A.53.53,0,0,0,417.25,291.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.05,289.33a.36.36,0,0,0,.11-.14.45.45,0,0,0,0-.53.46.46,0,0,0-.64-.06.36.36,0,0,0-.11.14.45.45,0,0,0,0,.53A.46.46,0,0,0,417.05,289.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.86,295a.46.46,0,0,0-.64-.06.44.44,0,0,0-.15.25l.89.09A.56.56,0,0,0,416.86,295Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,284.3a.44.44,0,0,0-.07.63.46.46,0,0,0,.63.07.45.45,0,1,0-.56-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.23,286.74h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.26,288.23a.45.45,0,0,0-.63-.06.44.44,0,0,0-.07.63.46.46,0,0,0,.63.07A.45.45,0,0,0,415.26,288.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,291.18a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,414.75,291.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.26,292.47a.45.45,0,0,0-.06.63.46.46,0,0,0,.63.07.47.47,0,0,0,.07-.64A.46.46,0,0,0,414.26,292.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.37,287.45a.53.53,0,0,0,.12-.14.45.45,0,0,0-.66-.6.79.79,0,0,0-.12.15.45.45,0,0,0,0,.53A.45.45,0,0,0,419.37,287.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.35,291.16a.45.45,0,0,0,0,.53.46.46,0,0,0,.64.06.36.36,0,0,0,.11-.14.45.45,0,0,0,0-.53.47.47,0,0,0-.64-.07A.48.48,0,0,0,418.35,291.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,293.53a.47.47,0,0,0,.64.07.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06A.46.46,0,0,0,416.07,293.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.4,296.06a.46.46,0,0,0-.63-.07.32.32,0,0,0-.08.09l.21,0h0l.36,0h.15A.25.25,0,0,0,425.4,296.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.09,295.33l.64.05h0a.45.45,0,0,0-.63-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.32,283.09a.45.45,0,0,0-.06.63.44.44,0,0,0,.63.07.46.46,0,0,0,.12-.55h0l-.55-.23h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.09,293.74a.53.53,0,0,0,.12-.14.45.45,0,0,0,0-.53.46.46,0,0,0-.63-.07.44.44,0,0,0-.12.15.45.45,0,0,0,.66.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.78,284.57a.45.45,0,0,0-.63-.06.44.44,0,0,0-.07.63.46.46,0,0,0,.63.07A.45.45,0,0,0,419.78,284.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.57,289.29a.44.44,0,0,0,0-.52.46.46,0,0,0-.63-.07.44.44,0,0,0-.12.15.45.45,0,0,0,.66.59A.44.44,0,0,0,419.57,289.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,283.15a.45.45,0,0,0,.75-.48l-.55-.23a.5.5,0,0,0-.14.08A.45.45,0,0,0,419,283.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,285.57a.46.46,0,0,0,.63.07h0l.09-.06a.45.45,0,0,0-.56-.7h0a.21.21,0,0,0-.1.06A.45.45,0,0,0,421,285.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.33,289.87a.44.44,0,0,0,.12-.15.44.44,0,0,0,0-.52.46.46,0,0,0-.63-.07.44.44,0,0,0-.12.15.45.45,0,0,0,.66.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.77,283.53a.46.46,0,0,0,.07-.63.47.47,0,0,0-.64-.07.46.46,0,0,0-.06.64A.45.45,0,0,0,421.77,283.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,287.62l.1-.06a.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06h0l-.1.05a.46.46,0,0,0-.06.64.45.45,0,0,0,.63.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.41,291.86a.44.44,0,0,0,.12-.15.45.45,0,0,0-.66-.59.44.44,0,0,0-.12.15.45.45,0,0,0,.66.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,296h0a.45.45,0,0,0-.63-.06h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,294.17a.33.33,0,0,0,.11-.15.44.44,0,0,0,0-.52.47.47,0,0,0-.64-.07.33.33,0,0,0-.11.15.44.44,0,0,0,0,.52A.45.45,0,0,0,421,294.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.54,286.08c0-.16.07-.3.1-.42A.44.44,0,0,0,427.54,286.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.62,294.64a.46.46,0,0,0,.63.07.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06A.45.45,0,0,0,424.62,294.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.21,295.8a.49.49,0,0,0-.08-.25h.05a.16.16,0,0,0,0-.07.44.44,0,0,0-.63-.07.32.32,0,0,0-.08.09h0a.36.36,0,0,0-.11.21h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,285.15a.45.45,0,0,0-.64-.07l0,0v0l0,.05a.45.45,0,0,0,0,.57.44.44,0,0,0,.63.07A.46.46,0,0,0,424,285.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,287.56a.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63.46.46,0,0,0,.63.07A.47.47,0,0,0,426,287.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.61,290.41a.45.45,0,1,0-.56-.7.44.44,0,0,0-.07.63A.46.46,0,0,0,425.61,290.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.85,286.21a.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06.46.46,0,0,0-.07.63A.45.45,0,0,0,425.85,286.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.7,292.39a.45.45,0,0,0,.06-.63.45.45,0,1,0-.06.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.66,292.22a.46.46,0,0,0,.63.07.47.47,0,0,0,.07-.64.46.46,0,0,0-.64-.06A.45.45,0,0,0,422.66,292.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,294.28a.45.45,0,1,0-.56-.7.44.44,0,0,0-.07.63A.46.46,0,0,0,423.37,294.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.8,289.34a.45.45,0,0,0-.63-.06.46.46,0,0,0-.07.63.47.47,0,0,0,.64.07A.46.46,0,0,0,423.8,289.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.65,288a.45.45,0,1,0-.56-.7.44.44,0,0,0-.07.63A.46.46,0,0,0,423.65,288Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,296.42l-.41,0c-3.06-.17-13.09-.85-13.42-2.38s3.85-11,6.71-11.92,8.69,2.78,8.94,2.94l.15.09,0,.18c-1.21,4.86-2.32,10.2-2.09,10.74Zm-6-14a2.81,2.81,0,0,0-.94.14c-2.58.86-6.68,10-6.38,11.34.16.77,6.64,1.61,12.66,2-.05-1.84,1.62-8.67,2.08-10.53C426.63,284.84,422.63,282.43,420,282.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.27,296.27s1.54-8.64,2.47-11,6.86-3.74,8.52-1.66-3.22,12-3.22,12Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.64,283.8a.46.46,0,0,0-.63-.07.47.47,0,0,0-.07.64.46.46,0,0,0,.64.06A.45.45,0,0,0,430.64,283.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.28,288.1a.46.46,0,0,0-.63-.07.45.45,0,1,0,.56.7A.44.44,0,0,0,430.28,288.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.28,292.33a.46.46,0,0,0-.06.64.45.45,0,0,0,.63.06.46.46,0,0,0,.07-.63A.47.47,0,0,0,429.28,292.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,286a.46.46,0,0,0-.06.64.45.45,0,0,0,.63.06.46.46,0,0,0,.07-.63A.47.47,0,0,0,429.56,286Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.13,291a.46.46,0,0,0,.64.06.45.45,0,0,0,.06-.63.46.46,0,0,0-.63-.07A.47.47,0,0,0,429.13,291Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,288.63a.46.46,0,0,0,.06-.64.45.45,0,0,0-.63-.06.46.46,0,0,0-.07.63A.47.47,0,0,0,427.81,288.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.9,295.18a.45.45,0,0,0,.7-.57.47.47,0,0,0-.64-.07A.46.46,0,0,0,428.9,295.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.55,285.82v0a.44.44,0,0,0,.71.46.44.44,0,0,0,.07-.63.46.46,0,0,0-.63-.07A.41.41,0,0,0,427.55,285.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,290.62A.47.47,0,0,0,428,290a.46.46,0,0,0-.64-.06.45.45,0,0,0-.06.63A.46.46,0,0,0,427.89,290.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,294.11a.45.45,0,0,0-.07.64.46.46,0,0,0,.64.06.45.45,0,0,0,.06-.63A.46.46,0,0,0,427.09,294.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57,292.82a.44.44,0,0,0,.07-.63.47.47,0,0,0-.64-.07.46.46,0,0,0-.06.64A.45.45,0,0,0,427.57,292.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.41,287.28a.45.45,0,1,0-.63-.07A.44.44,0,0,0,434.41,287.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.46,289.1a.45.45,0,0,0,.63.06.46.46,0,0,0,.07-.63.47.47,0,0,0-.64-.07A.46.46,0,0,0,431.46,289.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.6,284.51a.45.45,0,0,0-.7.57.47.47,0,0,0,.64.07A.46.46,0,0,0,434.6,284.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.42,291.51a.44.44,0,0,0,.63.07.46.46,0,0,0,.07-.63.45.45,0,1,0-.7.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.72,289.09a.46.46,0,0,0-.08.25C435.67,289.25,435.69,289.17,435.72,289.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.84,284.88a.45.45,0,0,0-.06.63.46.46,0,0,0,.63.07.45.45,0,0,0,.07-.64A.46.46,0,0,0,435.84,284.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.82,283.09a.44.44,0,0,0,.63.07.46.46,0,0,0,.15-.49,5.27,5.27,0,0,0-.81-.11A.45.45,0,0,0,433.82,283.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.45,284.86a.44.44,0,0,0,.07-.63.45.45,0,1,0-.07.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.61,290.45a.45.45,0,1,0,.63.07A.44.44,0,0,0,431.61,290.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5,289.27a.45.45,0,0,0,.06-.63.44.44,0,0,0-.63-.07.46.46,0,0,0-.07.63A.45.45,0,0,0,434.5,289.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.09,293.4a.46.46,0,0,0,.64.06.45.45,0,0,0,.06-.63.46.46,0,0,0-.63-.07A.47.47,0,0,0,431.09,293.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,286.15a.46.46,0,0,0-.07.63.45.45,0,1,0,.7-.56A.44.44,0,0,0,432,286.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,296.55l.06-.32c.06-.36,1.55-8.7,2.48-11.08.58-1.49,2.82-2.47,4.66-2.75s3.54.09,4.28,1c1.72,2.14-2.68,11.28-3.19,12.31l-.06.13Zm8.45-13.75a8.09,8.09,0,0,0-1.17.09c-2.08.32-3.84,1.32-4.28,2.44-.81,2.08-2.1,9.08-2.39,10.67l7.3-.61c1.37-2.83,4.45-10.08,3.18-11.66A3.3,3.3,0,0,0,433.42,282.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,296.14s.75-2.21,4.78-2.18c3.2,0,3.33,2,1.46,2.08S425.66,296.14,425.66,296.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.67,296.39h-.35l.11-.33c0-.09.83-2.35,4.91-2.35h.1c2,0,2.91.76,2.93,1.48,0,.51-.44,1-1.46,1.1C430.06,296.39,425.71,296.39,425.67,296.39Zm4.67-2.18c-2.8,0-3.89,1.11-4.26,1.68,1.13,0,4.3,0,5.8-.1.59,0,1-.27,1-.59s-.68-1-2.43-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.31,275.89s.61-2.52-.6-3.52-3.52,1-3.52,1-1.91-2.81-2.91-1.2a6.84,6.84,0,0,0-1.11,2.61s-2.21-2.31-3.22-1.11-.4,1.81-.4,1.81-3-.2-3.22.71a1.57,1.57,0,0,0,.3,1.41s-1.5.1-1.71,1.2a2,2,0,0,0,.41,1.71s-1,1.31-.51,1.61,1.81.91,1.81.91-2.51,1.3-2.21,2.41a2.27,2.27,0,0,0,1.61,1.41s-1.11,1.1-.4,1.51a1.91,1.91,0,0,0,1.21.3s-.71,1,.3,1.3a3.27,3.27,0,0,0,1.71.11s-.41,1.2.2,1.5a2.62,2.62,0,0,0,1.51.1,1.12,1.12,0,0,0,.5,1.61,2.33,2.33,0,0,0,2,0s.1,1.51.8,1.31a4,4,0,0,0,1.41-.9s-.3.7.81.7,1.5-1.31,1.5-1.31,1,1.31,1.81,1a1.14,1.14,0,0,0,.81-1s.6.91,1.31.61a2.16,2.16,0,0,0,.9-.61s.2.71,1.21,0,1-1.41,1-1.41,1.11,0,1.41-.8a2.29,2.29,0,0,0,.1-1.41,3.35,3.35,0,0,0,1.31-2.41c-.1-1.31-.4-1.41-.4-1.41s1.2-1.61,1.1-2.31l-.1-.71s1-1.2.2-2.11-1.4-.9-1.4-.9.9-1.81,0-2.11a5.06,5.06,0,0,0-2.62.4S450.34,272.87,446.31,275.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.75,294.86a.63.63,0,0,1-.37-.12,1.78,1.78,0,0,1-.52-1.1,2.64,2.64,0,0,1-1.9-.13,1.26,1.26,0,0,1-.75-.77,1.33,1.33,0,0,1,0-.76,2.53,2.53,0,0,1-1.24-.18c-.55-.27-.51-1-.43-1.43a3.77,3.77,0,0,1-1.45-.17.94.94,0,0,1-.67-.57,1.07,1.07,0,0,1,0-.73,2.55,2.55,0,0,1-.93-.33.67.67,0,0,1-.35-.5,1.67,1.67,0,0,1,.45-1.11,2.28,2.28,0,0,1-1.42-1.46c-.27-1,1.15-2,1.91-2.45-.43-.21-1.07-.52-1.39-.72a.5.5,0,0,1-.25-.36,2.4,2.4,0,0,1,.56-1.45,2.33,2.33,0,0,1-.33-1.76,1.84,1.84,0,0,1,1.53-1.35,1.94,1.94,0,0,1-.12-1.28c.2-.88,2.12-.94,3.06-.91a2,2,0,0,1,.61-1.71,1.17,1.17,0,0,1,.89-.43h.05a4.17,4.17,0,0,1,2.32,1.21,9,9,0,0,1,1-2.26,1.16,1.16,0,0,1,1-.61h0c.89,0,1.82,1.1,2.19,1.59.63-.49,2.5-1.78,3.63-.84.94.78.9,2.31.79,3.17,1-.68,1.79-.84,2.31-.5.78.5.69,1.93.58,2.67a4.39,4.39,0,0,1,2.37-.25.8.8,0,0,1,.5.45,2.64,2.64,0,0,1-.22,1.72,3,3,0,0,1,1.24.92,1.85,1.85,0,0,1-.13,2.34l.09.6c.1.67-.69,1.85-1,2.33a3.34,3.34,0,0,1,.33,1.41,3.41,3.41,0,0,1-1.28,2.52,2.69,2.69,0,0,1-.14,1.41,1.69,1.69,0,0,1-1.43,1,2.51,2.51,0,0,1-1.08,1.38,1.32,1.32,0,0,1-1.16.31.58.58,0,0,1-.22-.13,3.35,3.35,0,0,1-.78.45,1.17,1.17,0,0,1-1.28-.33,1.45,1.45,0,0,1-.84.73c-.69.26-1.43-.36-1.82-.77a1.82,1.82,0,0,1-1.58,1.09,1.12,1.12,0,0,1-1-.38l0-.06a3.42,3.42,0,0,1-1.13.63A.63.63,0,0,1,438.75,294.86Zm-.46-2,0,.39a1.78,1.78,0,0,0,.35,1.06.13.13,0,0,0,.14,0,3.61,3.61,0,0,0,1.29-.84l.92-.92-.51,1.19h0a.3.3,0,0,0,0,.21s.15.15.57.15c.9,0,1.26-1.12,1.27-1.13l.14-.46.29.38c.24.3,1,1.12,1.53.92a.89.89,0,0,0,.64-.77l0-.79.44.65s.5.72,1,.52a2.1,2.1,0,0,0,.8-.52l.3-.42.14.49h0a.2.2,0,0,0,.13.12c.06,0,.27.05.69-.25.87-.61.9-1.19.9-1.21v-.24h.24s.94,0,1.18-.64a2,2,0,0,0,.09-1.24l0-.16.14-.11s1.3-1,1.21-2.2-.28-1.22-.28-1.22l-.33-.11.26-.25a5,5,0,0,0,1.06-2.13l-.12-.81.07-.09s.86-1,.21-1.78-1.22-.82-1.23-.82l-.38,0,.16-.34a2.57,2.57,0,0,0,.33-1.59.27.27,0,0,0-.18-.18,4.7,4.7,0,0,0-2.44.4l-.45.18.11-.47c.12-.54.32-2.18-.29-2.58-.4-.25-1.19,0-2.24.83l-.55.41.16-.67s.55-2.38-.52-3.27c-.85-.71-2.59.48-3.19,1l-.22.19-.15-.24c-.31-.44-1.24-1.59-1.94-1.59h0a.66.66,0,0,0-.55.38,6.68,6.68,0,0,0-1.07,2.51l-.06.53L438,275a4.39,4.39,0,0,0-2.32-1.37.69.69,0,0,0-.53.25c-.83,1-.43,1.46-.41,1.48l.42.46-.62,0c-1.35-.08-2.86.1-2.95.51a1.33,1.33,0,0,0,.23,1.18l.37.39-.53,0s-1.32.1-1.48,1a1.7,1.7,0,0,0,.34,1.49l.14.15-.13.18c-.26.34-.63,1-.58,1.21.5.32,1.79.91,1.8.92l.46.21-.45.24c-.9.47-2.27,1.46-2.09,2.12a2,2,0,0,0,1.43,1.23l.43.11-.31.31c-.26.26-.6.73-.56,1,0,0,0,.09.1.14a1.73,1.73,0,0,0,1,.27l.59-.1-.34.49a1,1,0,0,0-.18.67s.06.17.35.26a3.2,3.2,0,0,0,1.57.1l.45-.13-.15.44c-.11.33-.23,1.06.08,1.21a2.44,2.44,0,0,0,1.34.08l.53-.12-.25.48a1.07,1.07,0,0,0-.1.79.87.87,0,0,0,.48.48,2.08,2.08,0,0,0,1.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.93,286c-.69,0-1.6-.13-1.92-.77a.73.73,0,0,1,0-.63,2.73,2.73,0,0,1,1.49-1.07,3.32,3.32,0,0,1-1.32-.82.58.58,0,0,1-.13-.65c.21-.44,1.06-.47,1.22-.47a.26.26,0,0,1,.25.26.25.25,0,0,1-.25.24,1.34,1.34,0,0,0-.77.19h0a.32.32,0,0,0,.07.11,4,4,0,0,0,1.78.88l1,.22-.94.26c-.64.18-1.72.63-1.9,1.05a.22.22,0,0,0,0,.21c.3.59,1.75.51,2.24.44a.25.25,0,1,1,.08.49A6.69,6.69,0,0,1,434.93,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.25,286.88s-2,2.24-.9,3,2.76-1.22,2.76-1.22-.58.71.07.58,1.73-1.67,1.73-1.67-1.61,4.56-.26,4.81,1.8-2.75,1.8-2.75.25,2.95,1.6,2.18.9-3.15.9-3.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.81,292.66l-.21,0a.78.78,0,0,1-.54-.4c-.41-.72-.09-2.35.23-3.5a2.51,2.51,0,0,1-1.07.76.55.55,0,0,1-.49-.09c-.63.57-1.68,1.28-2.52.69a1,1,0,0,1-.42-.72c-.13-1.05,1.13-2.51,1.27-2.67a.26.26,0,0,1,.36,0,.25.25,0,0,1,0,.35c-.35.4-1.24,1.58-1.16,2.28a.5.5,0,0,0,.22.37c.87.62,2.41-1.16,2.42-1.18l.38.32-.1.15a5.38,5.38,0,0,0,1.5-1.54l1-1.46-.6,1.69c-.33.94-1.09,3.55-.65,4.32a.33.33,0,0,0,.21.16.6.6,0,0,0,.46-.11,4.5,4.5,0,0,0,1-2.44l.31-2.09.19,2.1c.05.67.31,1.81.76,2,.08.05.22.09.47,0,1.17-.67.78-2.86.77-2.88a.25.25,0,0,1,.2-.29.24.24,0,0,1,.29.2c0,.1.47,2.55-1,3.4a.92.92,0,0,1-.94.06,2,2,0,0,1-.81-1.26,3.35,3.35,0,0,1-1,1.62A1.09,1.09,0,0,1,439.81,292.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.86,286.43c-.82,0-1.5-.06-1.66-.07a.26.26,0,0,1-.23-.27.23.23,0,0,1,.27-.23c1.42.13,3.86.12,4.39-.44a.28.28,0,0,0,.09-.24c-.17-1.19-2.45-1.39-2.47-1.39v-.5c1-.11,2.63-.5,2.94-1.05a.35.35,0,0,0,0-.33.25.25,0,1,1,.45-.2.81.81,0,0,1,0,.77,3.4,3.4,0,0,1-2.05,1.08,2.11,2.11,0,0,1,1.65,1.55.75.75,0,0,1-.22.66C451.48,286.31,450,286.43,448.86,286.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,292.41c-1.65,0-3.62-2.94-3.84-3.28a.24.24,0,0,1,.07-.34.25.25,0,0,1,.35.07c.56.85,2.25,3.05,3.42,3.05h0a1,1,0,0,0,.8-.6C449.88,289,447,287,446.89,287a.25.25,0,0,1-.07-.35.25.25,0,0,1,.34-.07s3.39,2.28,1.88,5a1.44,1.44,0,0,1-1.22.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.76,282l-.11,0c-.74-.39-3.16-1.71-3.35-2.4a.38.38,0,0,1,.05-.33c.27-.44,1.25-.4,2-.3-.83-1-2-2.57-2-3.1a.32.32,0,0,1,.13-.25c.28-.23,1.17,0,2.63.75-.72-1-1-1.68-.88-2a.35.35,0,0,1,.33-.19c.69,0,2.3,2,3,2.92a.25.25,0,0,1-.4.3,15.7,15.7,0,0,0-2.37-2.64,13.55,13.55,0,0,0,1.42,2.14l.74.95-1.06-.57a13.48,13.48,0,0,0-3-1.3,17.92,17.92,0,0,0,2.27,3.16l.46.55-.71-.15a4.48,4.48,0,0,0-2.14-.08,12,12,0,0,0,3.08,2.06.25.25,0,0,1,.11.33A.27.27,0,0,1,436.76,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.68,276.61h0a.26.26,0,0,1-.25-.26l0-.64a.25.25,0,1,1,.5,0l0,.63A.25.25,0,0,1,441.68,276.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.57,280.39h0a.25.25,0,0,1-.25-.25l.09-3.08a.26.26,0,0,1,.25-.25h0a.25.25,0,0,1,.24.26l-.09,3.08A.24.24,0,0,1,441.57,280.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.36,279.79a.27.27,0,0,1-.17-.06.25.25,0,0,1,0-.36l.28-.29a.24.24,0,0,1,.35,0,.25.25,0,0,1,0,.36l-.28.3A.23.23,0,0,1,446.36,279.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,281.48a.27.27,0,0,1-.17-.06.25.25,0,0,1,0-.36l1.24-1.32a.25.25,0,0,1,.36.34L445,281.41A.23.23,0,0,1,444.78,281.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,285.14h-.06l-.5-.12a.25.25,0,1,1,.12-.48l.5.12a.25.25,0,0,1,.18.3A.26.26,0,0,1,448,285.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.08,284.92H447l-1.78-.43a.25.25,0,0,1-.19-.3.25.25,0,0,1,.3-.19l1.79.43a.24.24,0,0,1,.18.3A.24.24,0,0,1,447.08,284.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.6,288.54a.25.25,0,0,1-.25-.25v-1.6a.25.25,0,1,1,.5,0v1.6A.25.25,0,0,1,442.6,288.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.53,286.94a.3.3,0,0,1-.14-.05.25.25,0,0,1-.06-.35l.83-1.21a.25.25,0,0,1,.35-.07.25.25,0,0,1,.06.35l-.83,1.22A.26.26,0,0,1,437.53,286.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.13,280.29a.22.22,0,0,1-.13,0l-.24-.15a.25.25,0,1,1,.27-.42l.24.15a.26.26,0,0,1,.07.35A.25.25,0,0,1,437.13,280.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,281.29a.23.23,0,0,1-.14,0l-1-.67a.26.26,0,0,1-.08-.35.26.26,0,0,1,.35-.07l1,.67a.26.26,0,0,1,.08.35A.26.26,0,0,1,438.69,281.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,280.33a.25.25,0,0,1-.24-.18l-.58-2a.26.26,0,0,1,.17-.31.25.25,0,0,1,.31.17l.58,2a.25.25,0,0,1-.17.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,283.64a4,4,0,1,1-4-3.5A3.78,3.78,0,0,1,446.13,283.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,287.38a3.78,3.78,0,1,1,4.26-3.74A4,4,0,0,1,442.12,287.38Zm0-7a3.28,3.28,0,1,0,3.76,3.25A3.54,3.54,0,0,0,442.12,280.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3,266.72s-.83-2.51-1.22-1.73a3.29,3.29,0,0,0-.23,1.79s-1.89-1.51-2.06-.73a4.69,4.69,0,0,0,.5,2.18s-1.67-1.06-1.56-.06a2.23,2.23,0,0,0,.39,1.28s-2.4-.83-2.34,0a.92.92,0,0,0,.67.95s-1.06,0-.84.39,1.28.56,1.28.56-2.12.45-1.73,1a1.55,1.55,0,0,0,1.17.56s-.66.34-.33.56,1.17,0,1.17,0-1.06,1.06-.5,1.45,2.29-.22,2.29-.22-2.63,2.51-1.84,2.78a1.85,1.85,0,0,0,1.45-.11s-.51.56,0,.45a2.63,2.63,0,0,0,1.06-.78s-1.34,2-.67,2.68S405,277.6,405,277.6s.17,2.17.78,1.5.89-4,.89-4,.45,3.79,1.4,3.46-.06-4-.06-4,2.62.06,2.79-.72-2-1.51-2-1.51,3.63-.44,4.24-1.78-3.07-.84-3.4-.78.39-2.18.28-3.46-1.06-.5-1.06-.5-.06-2.18-.56-1.56a7.28,7.28,0,0,0-.89,2.06s-.28-1.78-.84-1.17A1.78,1.78,0,0,0,406.3,266.72Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.19,280.07a.57.57,0,0,1-.41-.18c-.44-.44-.25-1.22,0-1.89a.7.7,0,0,1-.19.06c-.29.07-.42,0-.48-.14a.31.31,0,0,1-.05-.12,2.1,2.1,0,0,1-1.06-.08.47.47,0,0,1-.3-.33c-.1-.5.68-1.46,1.38-2.19a2.2,2.2,0,0,1-1.58-.08.6.6,0,0,1-.27-.45,1.47,1.47,0,0,1,.3-.85,1.36,1.36,0,0,1-.7-.14.4.4,0,0,1-.2-.38.42.42,0,0,1,.09-.24,1.55,1.55,0,0,1-.79-.56.48.48,0,0,1-.06-.46,1.75,1.75,0,0,1,1-.68,1.11,1.11,0,0,1-.54-.45.44.44,0,0,1,0-.46.69.69,0,0,1,.37-.24,1.47,1.47,0,0,1-.24-.74.52.52,0,0,1,.21-.48c.38-.29,1.28-.12,1.91.05a4,4,0,0,1-.17-.84.58.58,0,0,1,.24-.62,1.28,1.28,0,0,1,1.08.1,3.53,3.53,0,0,1-.26-1.68.51.51,0,0,1,.33-.39c.43-.15,1.18.29,1.7.64a3.14,3.14,0,0,1,.28-1.37c.14-.27.32-.3.43-.29.29,0,.57.41.81.92a1.41,1.41,0,0,1,.31-.52.51.51,0,0,1,.54-.19,1,1,0,0,1,.51.63,4.68,4.68,0,0,1,.67-1.32.42.42,0,0,1,.47-.18c.28.09.45.59.51,1.48a.77.77,0,0,1,.58,0c.29.12.45.43.5.92a10.43,10.43,0,0,1-.23,2.32c-.06.31-.12.67-.14.88.69-.09,2.88-.32,3.42.38a.71.71,0,0,1,0,.78c-.47,1-2.38,1.56-3.55,1.79.68.32,1.47.83,1.33,1.45-.17.8-1.84.92-2.71.93.29,1.15.8,3.65-.18,4a.56.56,0,0,1-.53-.06,3.41,3.41,0,0,1-.9-1.93,5.93,5.93,0,0,1-.76,2.43.5.5,0,0,1-.54.19c-.3-.11-.47-.58-.57-1.07-.4.68-1,1.58-1.58,1.67Zm.24-3.19.4.3c-.5.76-1.06,2-.7,2.36a.09.09,0,0,0,.08,0c.4-.07,1.18-1.28,1.59-2.09l.4-.8.07.9a3.58,3.58,0,0,0,.32,1.38l0,0c.4-.44.72-2.57.82-3.81l.21-2.46.29,2.45c.14,1.18.53,3,1,3.24a.1.1,0,0,0,.09,0c.44-.15.24-2-.21-3.71l-.09-.32H408c1.13,0,2.46-.18,2.54-.52s-1-.94-1.85-1.22l-1.05-.35,1.1-.13c1-.12,3.59-.65,4-1.65.09-.17,0-.24,0-.26-.33-.43-2.25-.32-3.15-.16l-.13,0-.14-.11c-.17-.18-.13-.48,0-1.41a9.49,9.49,0,0,0,.23-2.19c0-.27-.1-.46-.19-.49s-.36.08-.46.16l-.4.32v-.5a6.2,6.2,0,0,0-.17-1.34,7.4,7.4,0,0,0-.79,1.9l-.31,1.13-.18-1.16a2.59,2.59,0,0,0-.37-1.08l0,0a1.54,1.54,0,0,0-.23,1.32l-.48.15a5.91,5.91,0,0,0-.77-1.66,3.18,3.18,0,0,0-.19,1.6l.11.64-.51-.41c-.69-.54-1.49-1-1.66-.89a4.18,4.18,0,0,0,.48,2l.37.78-.73-.46c-.53-.33-1.08-.52-1.17-.44s0,.05,0,.14a2.26,2.26,0,0,0,.32,1.14l.62.72-.88-.31a3.77,3.77,0,0,0-2-.3c0,.68.45.77.45.77l-.06.49a1.83,1.83,0,0,0-.58.06,2,2,0,0,0,1.07.39l1.56.17-1.54.32a3.44,3.44,0,0,0-1.58.64,1.38,1.38,0,0,0,1,.43h1l-.92.47a1.1,1.1,0,0,0-.24.15,2,2,0,0,0,.9-.06L402,273l-.65.66c-.26.26-.61.73-.59,1a.11.11,0,0,0,.05.09c.32.22,1.4,0,2.06-.25l1.1-.39-.84.81a7.24,7.24,0,0,0-1.91,2.4,1.66,1.66,0,0,0,1.22-.12l1.37-.81-.9,1A2.85,2.85,0,0,0,403.43,276.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.58,272.49a1.66,1.66,0,1,1-1.64-1.92A1.8,1.8,0,0,1,407.58,272.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,274.67a2.19,2.19,0,1,1,1.9-2.18A2.06,2.06,0,0,1,405.94,274.67Zm0-3.85a1.7,1.7,0,1,0,1.4,1.67A1.56,1.56,0,0,0,405.94,270.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,270.93a.24.24,0,0,1-.22-.14l-.78-1.56a.23.23,0,0,1,.11-.33.24.24,0,0,1,.33.11l.78,1.56a.25.25,0,0,1-.11.33A.2.2,0,0,1,405.41,270.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,270.81a.3.3,0,0,1-.15-.05l-.21-.16a.25.25,0,1,1,.29-.4l.22.16a.25.25,0,0,1,.05.35A.26.26,0,0,1,403.56,270.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.57,271.54a.23.23,0,0,1-.14,0l-.69-.5a.25.25,0,1,1,.29-.41l.69.5a.25.25,0,0,1,.06.35A.25.25,0,0,1,404.57,271.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85,274.67a.27.27,0,0,1-.19-.08.26.26,0,0,1,0-.36l.67-.61a.25.25,0,0,1,.35,0,.25.25,0,0,1,0,.36l-.67.61A.23.23,0,0,1,403.85,274.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.08,271.38a.27.27,0,0,1-.21-.12.27.27,0,0,1,.08-.35l1.12-.67a.25.25,0,0,1,.34.09.24.24,0,0,1-.08.34l-1.12.67A.2.2,0,0,1,407.08,271.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.38,268.76h0a.26.26,0,0,1-.23-.27l0-.4a.23.23,0,0,1,.28-.22.25.25,0,0,1,.22.27l0,.39A.25.25,0,0,1,406.38,268.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.19,270.82h0a.25.25,0,0,1-.23-.27l.12-1.29a.23.23,0,0,1,.27-.22.25.25,0,0,1,.23.27l-.12,1.28A.25.25,0,0,1,406.19,270.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,276.17a.28.28,0,0,1-.13,0,.25.25,0,0,1-.08-.35l.22-.37a.25.25,0,0,1,.43.27l-.23.36A.24.24,0,0,1,404.63,276.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,275.37a.31.31,0,0,1-.13,0,.26.26,0,0,1-.08-.35l.4-.65a.24.24,0,0,1,.34-.08.24.24,0,0,1,.08.34l-.4.65A.22.22,0,0,1,405.12,275.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,273.38H408l-.45-.11a.25.25,0,0,1-.18-.31.24.24,0,0,1,.3-.18l.45.11a.26.26,0,0,1,.18.31A.25.25,0,0,1,408.09,273.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.07,272.77a.25.25,0,0,1-.25-.24.24.24,0,0,1,.24-.26l1.23,0a.25.25,0,0,1,.25.25.24.24,0,0,1-.24.25l-1.23,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.58,263.38s2.07.61,1.73,0a2.74,2.74,0,0,0-1.09-1s1.9-.56,1.45-1a3.79,3.79,0,0,0-1.68-.69s1.49-.62.77-1a1.84,1.84,0,0,0-1-.34s1.68-1.21,1.1-1.57a.76.76,0,0,0-.95,0s.53-.69.13-.75-1,.6-1,.6.69-1.62.14-1.62a1.25,1.25,0,0,0-.92.52s.09-.61-.22-.49-.55.78-.55.78-.21-1.2-.73-1-.92,1.63-.92,1.63-.45-2.93-1-2.53a1.5,1.5,0,0,0-.6,1s-.14-.6-.3-.21a2.16,2.16,0,0,0,0,1.07s-.71-1.83-1.47-1.7.45,2.37.45,2.37-1.53-.91-1.37-.19,2.22,2.45,2.22,2.45-2.74-1.48-3-.69,2.71,1.85,2.71,1.85-1.27,1.72-.83,2.2,1.95-.64,1.95-.64-1.4,2.63-.8,3.67,2-1.66,2.12-1.91,1.27,1.28,2.18,1.81.83-.47.83-.47,1.47,1,1.3.36a5.79,5.79,0,0,0-1-1.57s1.32.65,1.17,0A1.42,1.42,0,0,0,452.58,263.38Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,266.56a.62.62,0,0,1-.56-.36c-.45-.77,0-2.2.41-3.11-.53.29-1.18.5-1.53.13s.2-1.64.62-2.25c-1-.4-2.79-1.21-2.56-2a.53.53,0,0,1,.31-.36,2.52,2.52,0,0,1,1.54.22,4.34,4.34,0,0,1-1.12-1.5.46.46,0,0,1,.15-.5,1,1,0,0,1,.91.07c-.26-.6-.52-1.37-.32-1.77a.53.53,0,0,1,.39-.29c.48-.09.92.36,1.23.85l0-.07a.37.37,0,0,1,.36-.28h.08a1.62,1.62,0,0,1,.55-.65.41.41,0,0,1,.4,0c.38.16.65,1,.82,1.84a1.7,1.7,0,0,1,.76-.92.57.57,0,0,1,.46,0,1.18,1.18,0,0,1,.42.55.93.93,0,0,1,.39-.35.36.36,0,0,1,.39.05.26.26,0,0,1,.11.14,1.3,1.3,0,0,1,.73-.24.42.42,0,0,1,.37.19,1.3,1.3,0,0,1,0,.94.79.79,0,0,1,.49-.1.41.41,0,0,1,.33.24.5.5,0,0,1,0,.34,1.2,1.2,0,0,1,.58.19.48.48,0,0,1,.24.4c0,.39-.48.89-.89,1.24a3,3,0,0,1,.58.26.51.51,0,0,1,.32.49,1,1,0,0,1-.5.65,2.75,2.75,0,0,1,1.16.61.45.45,0,0,1,.12.44c-.1.35-.68.64-1.17.83a2.7,2.7,0,0,1,.72.8.42.42,0,0,1,0,.47q-.21.24-.93.15a1.37,1.37,0,0,1,.15.37.48.48,0,0,1-.14.5.77.77,0,0,1-.59.08,3.68,3.68,0,0,1,.51,1,.39.39,0,0,1-.12.45c-.08.06-.31.22-1.23-.32a.59.59,0,0,1-.26.36.83.83,0,0,1-.89-.1,8,8,0,0,1-1.45-1.24l-.48-.47c-.29.56-1.13,2-1.87,2.08Zm1.19-5-.52,1c-.37.7-1.24,2.67-.8,3.42.07.12.11.11.13.11.39,0,1.21-1.31,1.54-2l.06-.12.16-.05c.23,0,.41.14,1,.7a7.89,7.89,0,0,0,1.34,1.16c.22.13.34.13.37.11a.48.48,0,0,0,.09-.35l0-.5.43.28a4.75,4.75,0,0,0,.86.47,6.46,6.46,0,0,0-.85-1.31l-.75-.9,1.05.52a2.44,2.44,0,0,0,.81.26,1.28,1.28,0,0,0-.74-.73l.15-.47a6.16,6.16,0,0,0,1.39.26,2.64,2.64,0,0,0-.92-.79l-.59-.28.62-.19a2.93,2.93,0,0,0,1.34-.66,3.82,3.82,0,0,0-1.54-.57l-.86-.14.8-.34a2,2,0,0,0,.81-.53l-.06,0a1.88,1.88,0,0,0-.89-.32l-.91.08.73-.53c.59-.42,1.14-1,1.12-1.15-.42-.24-.64,0-.64,0l-.38-.33a1.46,1.46,0,0,0,.2-.33,2,2,0,0,0-.65.5l-1.05,1.2.63-1.46a3,3,0,0,0,.32-1.31,1.18,1.18,0,0,0-.67.45l-.6.84.15-1a.49.49,0,0,0,0-.12,2,2,0,0,0-.29.54l-.32.87-.16-.91c-.05-.29-.2-.74-.36-.82-.29.08-.63.82-.81,1.46l-.31,1.12-.18-1.15a7.16,7.16,0,0,0-.65-2.34,1.39,1.39,0,0,0-.46.81l-.13,1.57-.18-.78-.44.14c-.26-.66-.84-1.6-1.2-1.55-.15.13.11,1.05.63,2l.42.79-.77-.46a3.92,3.92,0,0,0-1-.42,9.24,9.24,0,0,0,2.12,2.28l1.89,1.58-2.17-1.17a5.8,5.8,0,0,0-2.57-.87c-.11.33,1.1,1.06,2.52,1.57l.32.12-.2.27c-.59.8-1,1.71-.84,1.88s1-.21,1.61-.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.13,261.53a1.36,1.36,0,1,1,2.05-.2A1.46,1.46,0,0,1,448.13,261.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.12,262.1a2,2,0,0,1-1.13-.37,1.72,1.72,0,0,1-.58-2.34,1.46,1.46,0,0,1,1.1-.62,1.92,1.92,0,0,1,1.31.36,2,2,0,0,1,.78,1.1,1.47,1.47,0,0,1-1.48,1.87Zm-.44-2.84h-.12a1,1,0,0,0-.74.4,1.34,1.34,0,0,0,2.16,1.52,1,1,0,0,0,.13-.84,1.45,1.45,0,0,0-.58-.81A1.49,1.49,0,0,0,448.68,259.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.77,261.39h0l-1.41-.21a.25.25,0,1,1,.08-.49l1.4.21a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,260a.24.24,0,0,1-.24-.17.25.25,0,0,1,.15-.32l.21-.07a.27.27,0,0,1,.32.16.26.26,0,0,1-.16.32l-.2.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.34,260.33a.25.25,0,0,1-.24-.17.26.26,0,0,1,.16-.32l.65-.22a.25.25,0,0,1,.32.16.23.23,0,0,1-.15.31l-.66.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.69,259.12a.26.26,0,0,1-.25-.22l-.09-.73a.25.25,0,0,1,.49-.07l.1.74a.25.25,0,0,1-.22.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.2,263.14h0a.26.26,0,0,1-.23-.27l.08-1.05a.25.25,0,0,1,.27-.24.26.26,0,0,1,.23.27l-.08,1.06A.25.25,0,0,1,449.2,263.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.6,263.05a.25.25,0,0,1-.16-.06l-.25-.21a.25.25,0,0,1,0-.35.26.26,0,0,1,.36,0l.24.21a.24.24,0,0,1,0,.35A.25.25,0,0,1,451.6,263.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.87,262.43a.23.23,0,0,1-.16-.06l-.8-.68a.25.25,0,0,1,.32-.38l.8.68a.25.25,0,0,1,0,.35A.25.25,0,0,1,450.87,262.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.37,258.52a.24.24,0,0,1-.23-.15l-.14-.32a.25.25,0,0,1,.13-.33.25.25,0,0,1,.33.13l.13.32a.24.24,0,0,1-.13.33A.15.15,0,0,1,447.37,258.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.78,259.48a.25.25,0,0,1-.23-.16l-.25-.57a.25.25,0,0,1,.13-.33.26.26,0,0,1,.33.13l.25.58a.26.26,0,0,1-.14.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.47,261.81a.27.27,0,0,1-.19-.08.26.26,0,0,1,0-.36l.29-.24a.25.25,0,0,1,.35,0,.26.26,0,0,1,0,.36l-.29.24A.25.25,0,0,1,447.47,261.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.67,259.58a.25.25,0,0,1-.14,0,.25.25,0,0,1-.07-.34l.56-.84a.25.25,0,0,1,.42.28l-.56.83A.26.26,0,0,1,449.67,259.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.84,253.32s1.43-1.62.72-1.57a2.7,2.7,0,0,0-1.35.57s.28-1.95-.34-1.75-1.32,1.24-1.32,1.24.06-1.61-.6-1.12-.75.8-.75.8-.39-2-1-1.66a.76.76,0,0,0-.39.86s-.4-.77-.62-.43.13,1.14.13,1.14-1.18-1.32-1.41-.81a1.24,1.24,0,0,0,.08,1s-.51-.33-.53,0,.48.83.48.83-1.18-.31-1.23.24,1.1,1.52,1.1,1.52-2.85-.82-2.72-.16a1.49,1.49,0,0,0,.67,1s-.6-.13-.32.18a2.17,2.17,0,0,0,1,.43s-2-.12-2.16.62,2.34.59,2.34.59-1.47,1-.75,1.17,3.16-1,3.16-1-2.49,1.86-1.87,2.39,2.81-1.68,2.81-1.68,1,1.87,1.65,1.67.24-2,.24-2,1.8,2.37,3,2.26-.67-2.5-.85-2.72,1.7-.61,2.56-1.22-.08-1-.08-1,1.51-.93.87-1a6.09,6.09,0,0,0-1.82.21s1.14-.92.48-1.06A1.43,1.43,0,0,0,443.84,253.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.8,259.9c-.87,0-1.91-1-2.54-1.68,0,.6-.05,1.28-.53,1.44-.63.22-1.4-.87-1.78-1.5-.8.77-2.27,2-2.92,1.46a.51.51,0,0,1-.19-.43,2.48,2.48,0,0,1,.84-1.3,4.24,4.24,0,0,1-1.83.38.45.45,0,0,1-.39-.34c0-.25.16-.54.44-.8-.64,0-1.45-.1-1.73-.45a.5.5,0,0,1-.1-.47c.12-.48.71-.69,1.28-.77l-.05-.05c-.18-.2-.16-.36-.1-.45l0-.06a1.73,1.73,0,0,1-.36-.77.41.41,0,0,1,.13-.39c.3-.27,1.19-.16,2,0a1.69,1.69,0,0,1-.51-1.07.53.53,0,0,1,.23-.41,1,1,0,0,1,.66-.15,1,1,0,0,1-.15-.5.4.4,0,0,1,.21-.34.35.35,0,0,1,.17,0,1.39,1.39,0,0,1,.09-.76.42.42,0,0,1,.33-.25,1.28,1.28,0,0,1,.86.38.78.78,0,0,1,.11-.48.38.38,0,0,1,.37-.2.51.51,0,0,1,.3.13,1.18,1.18,0,0,1,.41-.43.5.5,0,0,1,.47-.06c.36.16.61.81.75,1.32a4.68,4.68,0,0,1,.48-.41.5.5,0,0,1,.58-.08.94.94,0,0,1,.38.73,2.65,2.65,0,0,1,1-.8.44.44,0,0,1,.45.08c.28.24.3.88.26,1.41a2.45,2.45,0,0,1,1-.32.38.38,0,0,1,.42.21c.1.19,0,.49-.25.9a1.38,1.38,0,0,1,.4,0,.47.47,0,0,1,.39.34.74.74,0,0,1-.17.56,3.76,3.76,0,0,1,1.1-.05.4.4,0,0,1,.36.3c0,.1.07.38-.81,1a.64.64,0,0,1,.22.39c0,.27-.12.53-.46.77a8.38,8.38,0,0,1-1.74.79l-.62.24c.38.5,1.38,1.88,1.1,2.57a.62.62,0,0,1-.57.38Zm-3.38-3.54.67.88c.48.63,1.87,2.25,2.77,2.16.13,0,.15-.06.16-.07.15-.37-.68-1.65-1.17-2.24l-.08-.1,0-.16c.06-.22.3-.32,1-.59a8.08,8.08,0,0,0,1.62-.73c.21-.15.26-.25.26-.29s-.16-.18-.28-.22l-.47-.19.43-.26a6.21,6.21,0,0,0,.79-.59,6.13,6.13,0,0,0-1.55.23l-1.13.3.91-.74a2.41,2.41,0,0,0,.58-.63,1.29,1.29,0,0,0-1,.37l-.37-.34a5.26,5.26,0,0,0,.82-1.14,2.53,2.53,0,0,0-1.1.5l-.5.41.09-.64a3,3,0,0,0,0-1.49,3.92,3.92,0,0,0-1.17,1.16l-.49.72,0-.87a2.17,2.17,0,0,0-.14-1l-.07,0a1.91,1.91,0,0,0-.65.67l-.31.87-.17-.9a3.09,3.09,0,0,0-.58-1.49c-.38.26-.3.54-.29.57l-.46.2a1.38,1.38,0,0,0-.22-.32,1.88,1.88,0,0,0,.18.8l.65,1.45-1.06-1.18a3,3,0,0,0-1.05-.84h0a1.2,1.2,0,0,0,.13.8l.51.89-.86-.56-.11-.06a2.34,2.34,0,0,0,.37.49l.65.66-.89-.24a1.59,1.59,0,0,0-.89,0c0,.3.48.92,1,1.35l.88.75-1.11-.32a7.38,7.38,0,0,0-2.4-.39,1.29,1.29,0,0,0,.54.75l1.38.78-.79-.16-.06.46c-.71-.05-1.8.06-1.9.44,0,.19,1,.34,2.08.27l.9-.05-.74.51a3.75,3.75,0,0,0-.8.71,9.14,9.14,0,0,0,3-1l2.24-1.05-2,1.48c-.89.66-1.86,1.61-1.87,2,.25.23,1.42-.56,2.48-1.63l.24-.24.16.29c.48.87,1.14,1.62,1.36,1.56s.22-1,.07-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.29,256.58a1.36,1.36,0,1,1,.69-1.94A1.47,1.47,0,0,1,440.29,256.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.42,257.08l-.33,0a1.47,1.47,0,0,1-1.14-2,2,2,0,0,1,2.2-1.28,1.46,1.46,0,0,1,1.14,2,2,2,0,0,1-.87,1A2,2,0,0,1,439.42,257.08Zm.4-2.81a1.5,1.5,0,0,0-.75.21,1.45,1.45,0,0,0-.65.76,1,1,0,0,0,.06.84,1,1,0,0,0,.7.47,1.4,1.4,0,0,0,1-.18,1.44,1.44,0,0,0,.65-.77,1,1,0,0,0-.76-1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.68,254.56a.37.37,0,0,1-.14,0,.26.26,0,0,1-.07-.35l.78-1.19a.26.26,0,0,1,.35-.07.25.25,0,0,1,.07.35l-.78,1.19A.26.26,0,0,1,440.68,254.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,253.21h0a.25.25,0,0,1-.23-.27l0-.22a.25.25,0,0,1,.27-.22.24.24,0,0,1,.22.27l0,.22A.25.25,0,0,1,440,253.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.91,254.22h0a.25.25,0,0,1-.22-.28l.07-.68A.25.25,0,0,1,440,253a.26.26,0,0,1,.23.28l-.07.68A.27.27,0,0,1,439.91,254.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.11,255.21l-.07,0-.71-.22a.25.25,0,0,1,.15-.47l.71.22a.25.25,0,0,1-.08.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,256.43a.27.27,0,0,1-.12,0l-.93-.51a.26.26,0,0,1-.1-.34.25.25,0,0,1,.34-.1l.93.51a.26.26,0,0,1,.1.34A.24.24,0,0,1,442,256.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.61,254.35a.24.24,0,0,1-.1-.47l.29-.14a.25.25,0,0,1,.33.12.25.25,0,0,1-.12.33l-.3.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.08,255.06a.25.25,0,0,1-.23-.14.25.25,0,0,1,.12-.33l1-.45a.26.26,0,0,1,.33.13.25.25,0,0,1-.12.33l-1,.44A.18.18,0,0,1,441.08,255.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,256.16h-.36a.25.25,0,0,1,0-.5H437a.26.26,0,0,1,.25.26A.26.26,0,0,1,437,256.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.05,256.19h0l-.63,0a.25.25,0,0,1,0-.5h0l.62,0a.24.24,0,0,1,.24.25A.25.25,0,0,1,438.05,256.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.05,257.45a.25.25,0,0,1-.24-.18l-.11-.36a.25.25,0,0,1,.17-.31.25.25,0,0,1,.31.17l.11.36a.26.26,0,0,1-.17.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,254.51a.25.25,0,0,1-.22-.12l-.52-.85a.25.25,0,0,1,.09-.34.24.24,0,0,1,.34.08l.52.85a.26.26,0,0,1-.08.35A.31.31,0,0,1,439,254.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.17,283.39s-1.31,2.3-.47,2.07a3.29,3.29,0,0,0,1.48-1s.15,2.42.84,2a4.72,4.72,0,0,0,1.28-1.83s.33,1.95,1,1.2.69-1.15.69-1.15,1,2.35,1.56,1.74a.92.92,0,0,0,.26-1.13s.67.83.85.36-.44-1.32-.44-1.32,1.75,1.28,1.9.61a1.56,1.56,0,0,0-.37-1.24s.7.27.64-.13-.78-.87-.78-.87,1.49.08,1.41-.59-1.69-1.55-1.69-1.55,3.62.27,3.3-.5a1.81,1.81,0,0,0-1.05-1s.75,0,.33-.3a2.63,2.63,0,0,0-1.29-.27s2.39-.34,2.44-1.29-3-.12-3-.12,1.51-1.58.6-1.58-3.54,2-3.54,2,2.52-2.87,1.64-3.35-2.95,2.73-2.95,2.73-1.71-2-2.4-1.59.22,2.5.22,2.5-2.75-2.4-4.16-2,1.43,2.84,1.69,3.05-1.87,1.16-2.75,2.1.33,1.13.33,1.13-1.58,1.49-.79,1.46a7.38,7.38,0,0,0,2.13-.72s-1.14,1.4-.31,1.41A1.81,1.81,0,0,0,423.17,283.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,286.76h-.1c-.48-.09-.95-.87-1.24-1.45a4.41,4.41,0,0,1-.52.69.57.57,0,0,1-.62.23c-.31-.08-.51-.48-.64-.86a3.56,3.56,0,0,1-1.08,1.31.52.52,0,0,1-.51,0c-.4-.21-.58-1.07-.66-1.69a3.15,3.15,0,0,1-1.21.71.44.44,0,0,1-.5-.13c-.18-.23-.07-.69.14-1.21a1.58,1.58,0,0,1-.58.12h0a.52.52,0,0,1-.5-.28,1,1,0,0,1,.12-.8,4.93,4.93,0,0,1-1.43.39h0a.41.41,0,0,1-.42-.24c-.11-.27.14-.73.77-1.36a.79.79,0,0,1-.41-.43,1,1,0,0,1,.35-1,9.88,9.88,0,0,1,1.88-1.37c.27-.17.58-.37.75-.5-.53-.45-2.17-1.91-2-2.79a.72.72,0,0,1,.56-.56c1.08-.35,2.74.73,3.69,1.44-.21-.72-.35-1.65.2-2,.7-.4,1.9.76,2.49,1.4.67-1,2.19-3,3.1-2.54a.6.6,0,0,1,.31.43,3.49,3.49,0,0,1-.83,2,5.83,5.83,0,0,1,2.3-1.06h0a.5.5,0,0,1,.51.28c.12.29-.12.73-.42,1.13.77-.15,1.87-.29,2.3.06a.55.55,0,0,1,.22.49c0,.63-.74,1-1.43,1.24l.18.11c.24.17.25.34.21.45a.24.24,0,0,1-.06.11,2,2,0,0,1,.65.85.43.43,0,0,1,0,.44c-.3.41-1.55.47-2.55.44.46.34,1,.79,1,1.23a.61.61,0,0,1-.16.5,1.46,1.46,0,0,1-.83.35,1.17,1.17,0,0,1,.36.61.43.43,0,0,1-.14.4.55.55,0,0,1-.25.1,1.43,1.43,0,0,1,.11,1,.45.45,0,0,1-.29.35,1.74,1.74,0,0,1-1.2-.31,1,1,0,0,1,0,.71.42.42,0,0,1-.34.29.65.65,0,0,1-.43-.12,1.37,1.37,0,0,1-.39.68A.54.54,0,0,1,429.35,286.76Zm-1.49-3.05.37.87c.32.77.85,1.63,1.11,1.68.47-.46.29-.81.27-.85l.41-.28a1.64,1.64,0,0,0,.43.39,2,2,0,0,0-.42-1.06l-.93-1.28,1.28.94a3.3,3.3,0,0,0,1.52.75,1.39,1.39,0,0,0-.32-1l-.69-.77,1,.38.28.07a2.18,2.18,0,0,0-.65-.63l-.77-.5.92,0a1.81,1.81,0,0,0,1.12-.21.1.1,0,0,0,0-.1c0-.38-.94-1-1.56-1.36l-1-.56,1.16.09a7.14,7.14,0,0,0,3.06-.19,1.7,1.7,0,0,0-.91-.83l-1.46-.48h1.3a2.59,2.59,0,0,0-.71-.07l0-.49c.9-.14,2.19-.55,2.22-1.06a.09.09,0,0,0,0-.08c-.32-.26-1.74,0-2.61.21l-.87.24.62-.65a3.7,3.7,0,0,0,.82-1.16h0c-.61,0-2.4,1.18-3.39,1.93l-2,1.49L429,277.3c.79-.89,1.85-2.37,1.76-2.88,0-.05,0-.06-.05-.08-.39-.22-1.68,1.19-2.62,2.64l-.18.28-.22-.25c-.74-.86-1.78-1.71-2.09-1.54s-.06,1.29.33,2.19l.44,1-.83-.72c-.74-.65-2.88-2.23-3.93-1.91-.18.06-.2.14-.2.17-.1.52,1.26,1.87,2,2.45l.1.08,0,.17c0,.25-.27.42-1.07.92a9.6,9.6,0,0,0-1.78,1.29c-.19.2-.28.38-.25.48s.31.21.44.23l.5.08-.37.35a6.51,6.51,0,0,0-.88,1,7.83,7.83,0,0,0,1.94-.67l1.05-.54-.74.92a2.43,2.43,0,0,0-.56,1h.06a1.6,1.6,0,0,0,1.13-.72l.43.25a6.21,6.21,0,0,0-.72,1.69,3.28,3.28,0,0,0,1.32-.93l.4-.5,0,.64a3.44,3.44,0,0,0,.45,1.83,4.26,4.26,0,0,0,1.19-1.71l.33-.81.15.86c.1.61.33,1.14.46,1.16s.05,0,.11-.09a2.26,2.26,0,0,0,.63-1Zm-5.19,1.57h0Zm.39-6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.6,278.58a1.66,1.66,0,1,1-.33,2.51A1.82,1.82,0,0,1,426.6,278.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.43,281.82a1.78,1.78,0,0,1-1.34-.57,1.75,1.75,0,0,1-.42-1.44,2.31,2.31,0,0,1,.77-1.42h0a2,2,0,0,1,2.88,0,1.75,1.75,0,0,1,.42,1.44,2.4,2.4,0,0,1-2.31,2Zm-.66-3.06a1.87,1.87,0,0,0-.61,1.12,1.3,1.3,0,0,0,.3,1,1.57,1.57,0,0,0,2.18-.08,1.87,1.87,0,0,0,.61-1.12,1.3,1.3,0,0,0-.3-1,1.57,1.57,0,0,0-2.18.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.07,283.28l-.09,0a.24.24,0,0,1-.14-.32l.64-1.63a.24.24,0,0,1,.32-.14.25.25,0,0,1,.14.33l-.64,1.62A.24.24,0,0,1,426.07,283.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.88,283.38a.27.27,0,0,1-.25-.23l0-.26a.25.25,0,0,1,.22-.28.24.24,0,0,1,.27.23l0,.26a.25.25,0,0,1-.22.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,282.71a.24.24,0,0,1-.24-.22l-.09-.85a.24.24,0,0,1,.22-.27.26.26,0,0,1,.28.22l.08.85a.24.24,0,0,1-.22.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53,280.32h0l-.9-.09a.25.25,0,0,1-.23-.27.24.24,0,0,1,.27-.23l.91.09a.24.24,0,0,1,.22.27A.25.25,0,0,1,430.53,280.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92,280.11h-.07l-1.24-.38a.25.25,0,0,1-.17-.31.26.26,0,0,1,.31-.17l1.25.38a.26.26,0,0,1,.16.32A.25.25,0,0,1,425.92,280.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13,282.62a.25.25,0,0,1-.2-.1.25.25,0,0,1,.05-.35l.32-.23a.24.24,0,0,1,.35.05.25.25,0,0,1,0,.35l-.32.23A.21.21,0,0,1,424.13,282.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.08,281.92a.22.22,0,0,1-.2-.1.24.24,0,0,1,.05-.35l1-.77a.25.25,0,0,1,.3.4l-1,.77A.24.24,0,0,1,425.08,281.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,278.81a.25.25,0,0,1-.25-.21.26.26,0,0,1,.2-.29l.43-.07a.25.25,0,0,1,.29.2.26.26,0,0,1-.2.29l-.43.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,279a.26.26,0,0,1-.25-.21.26.26,0,0,1,.2-.29l.75-.14a.25.25,0,0,1,.09.5l-.75.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,278.43a.26.26,0,0,1-.22-.13l-.21-.41a.25.25,0,0,1,.1-.34.25.25,0,0,1,.34.11l.21.4a.24.24,0,0,1-.1.34A.27.27,0,0,1,427,278.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.65,282.17a.27.27,0,0,1-.19-.08l-.84-.9a.25.25,0,0,1,0-.35.26.26,0,0,1,.36,0l.84.9a.25.25,0,0,1,0,.35A.28.28,0,0,1,429.65,282.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,277.84s.6-2.52-.61-3.52-3.52,1-3.52,1-1.91-2.81-2.91-1.2a6.78,6.78,0,0,0-1.11,2.61s-2.21-2.31-3.22-1.11-.4,1.81-.4,1.81-3-.2-3.22.71a1.56,1.56,0,0,0,.31,1.41s-1.51.1-1.71,1.2a2,2,0,0,0,.4,1.71s-1,1.31-.5,1.61,1.81.91,1.81.91-2.52,1.3-2.22,2.41A2.29,2.29,0,0,0,404,288.8s-1.1,1.1-.4,1.51a1.91,1.91,0,0,0,1.21.3s-.71,1,.3,1.3a3.19,3.19,0,0,0,1.71.1s-.4,1.21.2,1.51a2.72,2.72,0,0,0,1.51.1,1.12,1.12,0,0,0,.5,1.61,2.32,2.32,0,0,0,2,0s.1,1.51.81,1.31a4,4,0,0,0,1.4-.91s-.3.71.81.71,1.51-1.31,1.51-1.31,1,1.31,1.81,1a1.14,1.14,0,0,0,.8-1s.6.91,1.31.6a2.1,2.1,0,0,0,.9-.6s.2.71,1.21,0,1-1.41,1-1.41,1.1,0,1.4-.8a2.29,2.29,0,0,0,.1-1.41A3.35,3.35,0,0,0,425.4,289c-.1-1.31-.4-1.41-.4-1.41s1.21-1.61,1.1-2.31l-.1-.71s1-1.2.21-2.11-1.41-.9-1.41-.9.9-1.81,0-2.11a5.06,5.06,0,0,0-2.62.4S423.29,274.82,419.27,277.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.7,296.81a.6.6,0,0,1-.36-.12,1.74,1.74,0,0,1-.53-1.1,2.64,2.64,0,0,1-1.9-.13,1.26,1.26,0,0,1-.75-.77,1.41,1.41,0,0,1,0-.76,2.56,2.56,0,0,1-1.25-.18c-.54-.27-.51-1-.43-1.43a3.74,3.74,0,0,1-1.44-.17.94.94,0,0,1-.68-.57,1.2,1.2,0,0,1,0-.73,2.45,2.45,0,0,1-.92-.33.66.66,0,0,1-.36-.5,1.72,1.72,0,0,1,.45-1.11,2.28,2.28,0,0,1-1.42-1.46c-.27-1,1.15-2,1.91-2.45-.43-.21-1.07-.52-1.39-.71a.53.53,0,0,1-.25-.37,2.46,2.46,0,0,1,.56-1.45,2.33,2.33,0,0,1-.33-1.76,1.84,1.84,0,0,1,1.54-1.35,1.87,1.87,0,0,1-.13-1.28c.2-.88,2.13-.94,3.06-.91a2,2,0,0,1,.61-1.71,1.17,1.17,0,0,1,.89-.43,4,4,0,0,1,2.37,1.21,8.75,8.75,0,0,1,1-2.26,1.11,1.11,0,0,1,1-.61h0c.89,0,1.82,1.09,2.19,1.59.63-.49,2.5-1.78,3.63-.84.94.78.9,2.31.8,3.17,1-.68,1.78-.84,2.3-.5.78.5.69,1.93.59,2.67a4.38,4.38,0,0,1,2.37-.25.76.76,0,0,1,.49.45,2.58,2.58,0,0,1-.22,1.72,3,3,0,0,1,1.24.92,1.86,1.86,0,0,1-.12,2.34l.08.6c.1.67-.68,1.85-1,2.33a3.19,3.19,0,0,1,.33,1.41,3.43,3.43,0,0,1-1.28,2.52,2.69,2.69,0,0,1-.14,1.41,1.68,1.68,0,0,1-1.43.95,2.51,2.51,0,0,1-1.08,1.38,1.32,1.32,0,0,1-1.15.31.63.63,0,0,1-.23-.13,3.28,3.28,0,0,1-.77.44,1.16,1.16,0,0,1-1.29-.32,1.45,1.45,0,0,1-.84.73c-.69.26-1.43-.36-1.82-.77a1.82,1.82,0,0,1-1.58,1.09,1.12,1.12,0,0,1-1-.38l0-.06a3.42,3.42,0,0,1-1.13.63A.63.63,0,0,1,411.7,296.81Zm-.46-2,0,.39a1.85,1.85,0,0,0,.35,1.06.2.2,0,0,0,.14,0,4,4,0,0,0,1.3-.84l.91-.92-.51,1.19h0a.3.3,0,0,0,0,.21s.15.15.57.15c.91,0,1.26-1.12,1.27-1.13l.14-.46.29.38c.24.3,1,1.12,1.53.92a.89.89,0,0,0,.64-.77l0-.79.44.65s.49.73,1,.52a2.13,2.13,0,0,0,.8-.52l.3-.42.14.49h0a.24.24,0,0,0,.13.12c.06,0,.27.05.7-.25a1.8,1.8,0,0,0,.9-1.21v-.24h.24s.94,0,1.18-.64a2.12,2.12,0,0,0,.1-1.24l-.06-.17.14-.11s1.3-1,1.21-2.19-.28-1.22-.28-1.22l-.33-.11.26-.25a5,5,0,0,0,1.06-2.13l-.12-.81.07-.09s.86-1.05.21-1.78-1.22-.82-1.23-.82l-.38,0,.16-.34a2.67,2.67,0,0,0,.34-1.6.32.32,0,0,0-.19-.17,4.7,4.7,0,0,0-2.44.4l-.44.18.1-.47c.12-.54.32-2.19-.29-2.58-.39-.25-1.19,0-2.23.83l-.56.41.16-.67s.56-2.38-.52-3.27c-.85-.72-2.59.48-3.19,1l-.21.19-.16-.24c-.31-.44-1.24-1.59-1.94-1.59h0a.67.67,0,0,0-.55.38,6.9,6.9,0,0,0-1.07,2.51l-.06.53-.37-.39a4.43,4.43,0,0,0-2.29-1.37h0a.67.67,0,0,0-.52.25c-.83,1-.43,1.46-.42,1.48l.42.46-.61,0c-1.36-.09-2.87.1-3,.51a1.33,1.33,0,0,0,.23,1.18l.37.39-.53,0s-1.31.11-1.48,1a1.73,1.73,0,0,0,.34,1.49l.15.15-.13.17c-.27.35-.64,1-.59,1.22.5.32,1.79.91,1.8.92l.46.21-.45.24c-.9.47-2.27,1.46-2.08,2.12a2,2,0,0,0,1.42,1.23l.44.1-.32.32c-.25.26-.6.73-.56,1,0,0,0,.09.1.14a1.73,1.73,0,0,0,1,.27l.59-.1-.34.49a.92.92,0,0,0-.17.67s.06.17.34.25a2.93,2.93,0,0,0,1.57.1l.45-.12-.14.44c-.11.33-.24,1.06.07,1.21a2.44,2.44,0,0,0,1.34.08l.54-.12-.26.48a1.19,1.19,0,0,0-.1.79.82.82,0,0,0,.48.47,2.05,2.05,0,0,0,1.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,288c-.69,0-1.59-.13-1.91-.77a.7.7,0,0,1,0-.63,2.73,2.73,0,0,1,1.49-1.07,3.32,3.32,0,0,1-1.32-.82A.58.58,0,0,1,406,284c.21-.44,1.06-.47,1.22-.47a.25.25,0,0,1,.25.25.25.25,0,0,1-.25.25,1.44,1.44,0,0,0-.77.18h0a.4.4,0,0,0,.07.12,4,4,0,0,0,1.79.88l.95.22-.94.26c-.64.18-1.72.62-1.9,1a.23.23,0,0,0,0,.2c.3.6,1.76.52,2.24.45a.25.25,0,1,1,.08.49A6.69,6.69,0,0,1,407.88,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.76,294.61l-.2,0a.8.8,0,0,1-.55-.4c-.41-.72-.09-2.35.23-3.51a2.32,2.32,0,0,1-1.06.76.51.51,0,0,1-.49-.08c-.64.57-1.69,1.28-2.53.68a1,1,0,0,1-.42-.71c-.12-1.05,1.13-2.51,1.28-2.67a.25.25,0,1,1,.37.33c-.35.4-1.24,1.58-1.16,2.28a.5.5,0,0,0,.22.37c.87.62,2.41-1.16,2.42-1.18l.39.32-.11.15a5.53,5.53,0,0,0,1.51-1.54l1-1.46-.6,1.69c-.33.94-1.09,3.55-.64,4.32a.29.29,0,0,0,.2.16.6.6,0,0,0,.46-.11,4.5,4.5,0,0,0,1-2.44l.31-2.09.19,2.1c.06.67.31,1.81.76,2a.46.46,0,0,0,.47-.05c1.18-.68.78-2.86.77-2.88a.25.25,0,0,1,.5-.09c0,.1.46,2.55-1,3.4a.94.94,0,0,1-.95.06,2,2,0,0,1-.81-1.26,3.2,3.2,0,0,1-1,1.62A1.09,1.09,0,0,1,412.76,294.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,288.38c-.81,0-1.5-.06-1.66-.07a.26.26,0,0,1-.23-.27.24.24,0,0,1,.27-.23c1.42.13,3.86.12,4.4-.44a.27.27,0,0,0,.08-.24c-.16-1.19-2.44-1.39-2.47-1.39v-.5c1-.11,2.63-.51,2.94-1.06a.33.33,0,0,0,0-.32.25.25,0,0,1,.12-.33.24.24,0,0,1,.33.13.84.84,0,0,1,0,.77,3.46,3.46,0,0,1-2.05,1.08,2.12,2.12,0,0,1,1.64,1.55.77.77,0,0,1-.21.66C424.43,288.26,423,288.38,421.81,288.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09,290.94s3.27,5,4.68,2.44S420,288.7,420,288.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,294.36c-1.64,0-3.62-2.94-3.84-3.28a.26.26,0,0,1,.08-.35.25.25,0,0,1,.34.08c.56.85,2.26,3.05,3.42,3.05h0a1,1,0,0,0,.8-.6c1.29-2.33-1.59-4.27-1.71-4.35a.25.25,0,0,1-.07-.35.26.26,0,0,1,.35-.07s3.38,2.27,1.87,5a1.44,1.44,0,0,1-1.22.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.72,284l-.12,0c-.74-.39-3.16-1.71-3.34-2.4a.42.42,0,0,1,0-.33c.28-.44,1.25-.4,2-.3-.82-1-2-2.58-2-3.1a.35.35,0,0,1,.13-.25c.28-.23,1.17,0,2.64.75-.73-1-1-1.68-.89-2a.36.36,0,0,1,.33-.2c.69,0,2.3,2.05,3,2.93a.25.25,0,0,1-.4.3,15.3,15.3,0,0,0-2.37-2.64,13.55,13.55,0,0,0,1.42,2.14l.74.95-1.06-.58a13.41,13.41,0,0,0-3-1.29,18.48,18.48,0,0,0,2.27,3.16l.47.55-.71-.15a4.53,4.53,0,0,0-2.15-.08,12.45,12.45,0,0,0,3.08,2.06.24.24,0,0,1,.11.33A.25.25,0,0,1,409.72,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.64,278.55h0a.23.23,0,0,1-.24-.25v-.64a.25.25,0,0,1,.26-.24.24.24,0,0,1,.24.25v.64A.25.25,0,0,1,414.64,278.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.53,282.34h0a.24.24,0,0,1-.24-.25l.09-3.09a.25.25,0,0,1,.25-.24h0a.26.26,0,0,1,.25.26l-.09,3.08A.25.25,0,0,1,414.53,282.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.31,281.74a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.36l.28-.3a.25.25,0,0,1,.35,0,.26.26,0,0,1,0,.36l-.28.3A.26.26,0,0,1,419.31,281.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.73,283.43a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.36l1.24-1.32a.25.25,0,0,1,.36.34l-1.23,1.32A.24.24,0,0,1,417.73,283.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,287.09h-.06l-.5-.12a.25.25,0,1,1,.12-.48l.5.12a.25.25,0,0,1-.06.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,286.87H420l-1.78-.43a.25.25,0,0,1-.19-.3.26.26,0,0,1,.3-.19l1.79.43a.26.26,0,0,1,.19.3A.25.25,0,0,1,420,286.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.55,290.49a.25.25,0,0,1-.25-.25v-1.61a.26.26,0,0,1,.25-.25.25.25,0,0,1,.25.25v1.61A.25.25,0,0,1,415.55,290.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.49,288.88a.23.23,0,0,1-.14,0,.25.25,0,0,1-.07-.35l.83-1.21a.25.25,0,0,1,.35-.07.26.26,0,0,1,.07.35l-.84,1.22A.23.23,0,0,1,410.49,288.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.09,282.24a.23.23,0,0,1-.14,0l-.24-.15a.26.26,0,0,1-.08-.35.25.25,0,0,1,.35-.07l.24.15a.25.25,0,0,1-.13.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,283.24a.2.2,0,0,1-.13,0l-1.05-.67a.26.26,0,0,1-.08-.35.25.25,0,0,1,.35-.07l1,.67a.24.24,0,0,1,.07.34A.25.25,0,0,1,411.64,283.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.92,282.28a.25.25,0,0,1-.24-.18l-.57-2a.24.24,0,0,1,.17-.31.26.26,0,0,1,.31.17l.57,2a.24.24,0,0,1-.17.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.08,285.59a4,4,0,1,1-4-3.5A3.77,3.77,0,0,1,419.08,285.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,289.33a3.78,3.78,0,1,1,4.26-3.74A4,4,0,0,1,415.07,289.33Zm0-7a3.28,3.28,0,1,0,3.76,3.25A3.54,3.54,0,0,0,415.07,282.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,276.25s2.58-.61,1.84-1.07a3.45,3.45,0,0,0-1.76-.38s1.67-1.75.91-2a4.78,4.78,0,0,0-2.22.31s1.21-1.57.2-1.55a2.3,2.3,0,0,0-1.31.27s1.05-2.31.21-2.33a.94.94,0,0,0-1,.58s.15-1-.31-.87-.67,1.23-.67,1.23-.25-2.15-.84-1.81a1.52,1.52,0,0,0-.67,1.11s-.27-.69-.52-.38-.11,1.17-.11,1.17-1-1.16-1.39-.63,0,2.29,0,2.29-2.26-2.83-2.61-2.08a1.84,1.84,0,0,0,0,1.45s-.51-.55-.44,0a2.59,2.59,0,0,0,.68,1.13s-1.88-1.51-2.61-.91,1.93,2.25,1.93,2.25-2.18,0-1.57.64,3.86,1.24,3.86,1.24S440.72,276,441,277s4,.31,4,.31-.29,2.6.47,2.84,1.68-1.87,1.68-1.87.12,3.66,1.4,4.39,1.1-3,1.08-3.32,2.13.58,3.42.59.59-1,.59-1,2.17.14,1.61-.42a7.46,7.46,0,0,0-2-1.07s1.8-.12,1.24-.73A1.8,1.8,0,0,0,453,276.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.84,283a.84.84,0,0,1-.44-.13c-1-.56-1.33-2.51-1.46-3.69-.38.65-.95,1.38-1.57,1.2s-.74-1.92-.67-2.78c-1.18.18-3.71.46-4-.55a.58.58,0,0,1,.11-.52,3.48,3.48,0,0,1,2-.73,5.8,5.8,0,0,1-2.35-1,.49.49,0,0,1-.13-.56c.13-.29.62-.42,1.11-.47-.64-.46-1.48-1.17-1.52-1.72a.57.57,0,0,1,.21-.5c.48-.4,1.25-.14,1.88.2a1.29,1.29,0,0,1,0-.19c0-.3.08-.42.18-.47a.31.31,0,0,1,.13,0,2,2,0,0,1,.17-1.06.43.43,0,0,1,.36-.26c.5-.09,1.4.81,2.06,1.56a2.27,2.27,0,0,1,.21-1.57.64.64,0,0,1,.48-.22h0a1.38,1.38,0,0,1,.82.38,1.27,1.27,0,0,1,.2-.69.45.45,0,0,1,.4-.17.57.57,0,0,1,.23.12,1.57,1.57,0,0,1,.63-.74.47.47,0,0,1,.46,0,1.75,1.75,0,0,1,.59,1.08,1,1,0,0,1,.5-.49.43.43,0,0,1,.45.05.64.64,0,0,1,.2.39,1.61,1.61,0,0,1,.76-.17.52.52,0,0,1,.46.25c.26.41,0,1.28-.22,1.9a3.7,3.7,0,0,1,.86-.09.58.58,0,0,1,.59.29,1.22,1.22,0,0,1-.2,1.06,3.53,3.53,0,0,1,1.7-.1.54.54,0,0,1,.36.36c.11.44-.39,1.15-.79,1.63a3.26,3.26,0,0,1,1.34.41.44.44,0,0,1,.24.46c0,.28-.45.52-1,.72a1.48,1.48,0,0,1,.49.35.52.52,0,0,1,.14.56,1,1,0,0,1-.67.45,4.83,4.83,0,0,1,1.25.78.42.42,0,0,1,.14.49c-.12.27-.62.39-1.52.38a.79.79,0,0,1,0,.58,1,1,0,0,1-.94.41h0a10.51,10.51,0,0,1-2.29-.44c-.3-.08-.66-.18-.87-.21,0,.69.08,2.89-.69,3.37A.65.65,0,0,1,448.84,283Zm-1.5-5.84,0,1.11c0,1,.32,3.63,1.27,4.17.17.1.24,0,.27,0,.45-.29.51-2.21.44-3.12v-.13l.12-.13c.19-.16.49-.09,1.4.16a10.53,10.53,0,0,0,2.16.42h0c.26,0,.45-.06.5-.15s-.05-.37-.12-.47l-.29-.43.51,0a5.88,5.88,0,0,0,1.34-.05,7.86,7.86,0,0,0-1.81-1l-1.11-.4,1.18-.08a2.54,2.54,0,0,0,1.11-.27l0,0a1.51,1.51,0,0,0-1.3-.34l-.1-.49a6.1,6.1,0,0,0,1.72-.63,3.19,3.19,0,0,0-1.57-.33l-.65.05.45-.47c.6-.63,1.1-1.4,1-1.57a4.3,4.3,0,0,0-2.07.29l-.81.3.53-.69a2.13,2.13,0,0,0,.54-1.12s0,0-.14,0a2.22,2.22,0,0,0-1.17.22l-.76.55.38-.85a3.79,3.79,0,0,0,.48-2c-.67,0-.79.35-.81.39l-.48-.11a1.81,1.81,0,0,0,0-.58,1.87,1.87,0,0,0-.48,1l-.31,1.55-.19-1.57a3.21,3.21,0,0,0-.49-1.63,1.39,1.39,0,0,0-.52.93l-.1,1-.38-1a1.46,1.46,0,0,0-.13-.25,2.25,2.25,0,0,0,0,.9l.16.91-.6-.7c-.23-.28-.67-.68-.92-.68h0a.09.09,0,0,0-.09.05c-.25.29-.11,1.38.06,2.07l.29,1.13-.72-.91a7.41,7.41,0,0,0-2.22-2.12h0a1.68,1.68,0,0,0,0,1.23l.64,1.4-.89-.95a2.77,2.77,0,0,0,.44.56l-.34.37c-.71-.57-1.89-1.24-2.29-.91a.09.09,0,0,0,0,.08c0,.41,1.17,1.29,1.93,1.76l.77.48h-.9a3.78,3.78,0,0,0-1.41.19l0,0c.41.44,2.5.95,3.73,1.17l2.43.43-2.47.06c-1.19,0-3,.27-3.31.68a.12.12,0,0,0,0,.09c.12.45,2,.42,3.72.12l.33-.06,0,.33c-.12,1.14,0,2.48.3,2.58s1-.83,1.38-1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.1,277a1.67,1.67,0,1,1,2.06-1.47A1.81,1.81,0,0,1,447.1,277Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.3,277.27h-.22a1.91,1.91,0,1,1,2.33-1.69A2,2,0,0,1,447.3,277.27Zm-.18-.51a1.56,1.56,0,0,0,1.8-1.24,1.58,1.58,0,0,0-1.55-1.54,1.42,1.42,0,1,0-.25,2.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,275.26a.25.25,0,0,1-.23-.16.25.25,0,0,1,.14-.33l1.62-.63a.25.25,0,0,1,.33.14.24.24,0,0,1-.14.32l-1.63.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.39,273.43a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.36l.18-.2a.25.25,0,0,1,.37.33l-.17.2A.25.25,0,0,1,449.39,273.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.56,274.37a.27.27,0,0,1-.16-.06.26.26,0,0,1,0-.36l.55-.63a.25.25,0,0,1,.36,0,.26.26,0,0,1,0,.36l-.56.63A.25.25,0,0,1,448.56,274.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.07,274.09a.28.28,0,0,1-.2-.1l-.55-.72a.25.25,0,0,1,.4-.31l.55.73a.25.25,0,0,1,0,.35A.27.27,0,0,1,446.07,274.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.07,278.05a.24.24,0,0,1-.22-.14l-.57-1.17a.24.24,0,0,1,.12-.33.25.25,0,0,1,.33.11l.57,1.18a.24.24,0,0,1-.12.33A.2.2,0,0,1,449.07,278.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.57,276.49h-.05l-.39-.07a.25.25,0,0,1-.2-.29.25.25,0,0,1,.29-.2l.39.07a.25.25,0,0,1,.2.29A.25.25,0,0,1,451.57,276.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.41,276.28h-.05L449.1,276a.24.24,0,0,1-.2-.29.23.23,0,0,1,.29-.2l1.26.23a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3,274.27a.25.25,0,0,1-.15,0l-.35-.26a.25.25,0,1,1,.3-.4l.34.26a.25.25,0,0,1,.06.35A.28.28,0,0,1,444.3,274.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.31,275a.3.3,0,0,1-.15,0l-.61-.46a.25.25,0,0,1,.3-.4l.61.46a.24.24,0,0,1,.05.35A.26.26,0,0,1,445.31,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.42,277.7h-.09a.25.25,0,0,1-.15-.32l.15-.43a.26.26,0,0,1,.32-.16.25.25,0,0,1,.15.32l-.15.43A.23.23,0,0,1,446.42,277.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.4,274h0a.25.25,0,0,1-.23-.26l.08-1.23a.24.24,0,0,1,.26-.23.26.26,0,0,1,.24.27l-.09,1.22A.23.23,0,0,1,447.4,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49,261.3s.6-2.52-.6-3.52-3.52,1-3.52,1-1.91-2.81-2.92-1.2a7,7,0,0,0-1.11,2.61s-2.21-2.31-3.21-1.11-.41,1.81-.41,1.81-3-.2-3.21.71a1.57,1.57,0,0,0,.3,1.41s-1.51.1-1.71,1.2a2,2,0,0,0,.4,1.71s-1,1.31-.5,1.61,1.81.91,1.81.91-2.52,1.3-2.21,2.41a2.3,2.3,0,0,0,1.61,1.41s-1.11,1.1-.41,1.5a1.89,1.89,0,0,0,1.21.31s-.7,1,.3,1.3a3.19,3.19,0,0,0,1.71.1s-.4,1.21.2,1.51a2.72,2.72,0,0,0,1.51.1,1.13,1.13,0,0,0,.5,1.61,2.36,2.36,0,0,0,2,0s.1,1.51.81,1.31a4.06,4.06,0,0,0,1.41-.91s-.31.71.8.71,1.51-1.31,1.51-1.31,1,1.31,1.81,1a1.15,1.15,0,0,0,.8-1s.61.91,1.31.6a2.2,2.2,0,0,0,.91-.6s.2.7,1.2,0,1-1.41,1-1.41,1.1,0,1.41-.8a2.29,2.29,0,0,0,.1-1.41,3.38,3.38,0,0,0,1.3-2.41c-.1-1.31-.4-1.41-.4-1.41s1.21-1.61,1.11-2.31l-.1-.71s1-1.2.2-2.11S442,265,442,265s.91-1.81,0-2.12a5.12,5.12,0,0,0-2.61.41S440.51,258.28,436.49,261.3Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.92,280.27a.6.6,0,0,1-.36-.12,1.74,1.74,0,0,1-.53-1.1,2.64,2.64,0,0,1-1.9-.13,1.26,1.26,0,0,1-.75-.77,1.41,1.41,0,0,1,0-.76,2.56,2.56,0,0,1-1.25-.18c-.54-.27-.51-1-.42-1.43a3.77,3.77,0,0,1-1.45-.17.9.9,0,0,1-.67-.57,1.07,1.07,0,0,1,0-.73,2.49,2.49,0,0,1-.93-.33.64.64,0,0,1-.35-.5,1.65,1.65,0,0,1,.44-1.11,2.32,2.32,0,0,1-1.42-1.46c-.26-1,1.16-2,1.91-2.45-.43-.21-1.06-.52-1.39-.71a.57.57,0,0,1-.25-.37,2.41,2.41,0,0,1,.57-1.45,2.32,2.32,0,0,1-.34-1.76,1.85,1.85,0,0,1,1.54-1.35,1.93,1.93,0,0,1-.13-1.28c.2-.88,2.13-.94,3.06-.92a2,2,0,0,1,.61-1.7,1.21,1.21,0,0,1,.9-.43,3.91,3.91,0,0,1,2.36,1.21,9.12,9.12,0,0,1,1.05-2.26,1.11,1.11,0,0,1,1-.61h0c.9,0,1.82,1.09,2.19,1.59.63-.49,2.5-1.78,3.64-.84.93.78.89,2.31.79,3.17,1-.67,1.78-.84,2.31-.5.78.5.69,1.93.58,2.67a4.49,4.49,0,0,1,2.37-.25.76.76,0,0,1,.49.45,2.58,2.58,0,0,1-.22,1.72,3,3,0,0,1,1.24.92,1.86,1.86,0,0,1-.12,2.34l.08.6c.1.67-.68,1.85-1,2.33a3.19,3.19,0,0,1,.33,1.41,3.39,3.39,0,0,1-1.28,2.52,2.69,2.69,0,0,1-.14,1.41,1.68,1.68,0,0,1-1.43.95A2.53,2.53,0,0,1,439,278.7a1.32,1.32,0,0,1-1.16.31.63.63,0,0,1-.23-.13,3.28,3.28,0,0,1-.77.44,1.17,1.17,0,0,1-1.29-.32,1.43,1.43,0,0,1-.83.73c-.7.26-1.44-.36-1.83-.77a1.82,1.82,0,0,1-1.58,1.09,1.09,1.09,0,0,1-1-.38l0-.06a3.37,3.37,0,0,1-1.12.63A.69.69,0,0,1,428.92,280.27Zm-.45-2,0,.39c0,.35.15.92.36,1.06a.12.12,0,0,0,.13,0,4,4,0,0,0,1.3-.84l.92-.92-.51,1.19h0a.23.23,0,0,0,0,.2c0,.05.14.16.56.16.91,0,1.27-1.12,1.27-1.13l.14-.46.3.38c.23.3,1,1.12,1.52.92a.89.89,0,0,0,.64-.77l0-.79.44.65s.49.73,1,.51a2.06,2.06,0,0,0,.8-.51l.3-.42.15.49h0a.2.2,0,0,0,.12.12c.07,0,.27,0,.7-.25.87-.61.9-1.19.9-1.21v-.24h.24s.94,0,1.17-.64a2,2,0,0,0,.1-1.24l-.05-.17.13-.11s1.3-1,1.21-2.19-.28-1.22-.28-1.22l-.33-.11.26-.25a5,5,0,0,0,1.06-2.13L443,268l.07-.09s.86-1.05.21-1.78-1.22-.82-1.23-.82l-.38,0,.17-.34a2.65,2.65,0,0,0,.33-1.6.32.32,0,0,0-.19-.17,4.7,4.7,0,0,0-2.44.4l-.44.18.1-.47c.12-.54.33-2.19-.28-2.58-.4-.25-1.2,0-2.24.83l-.55.41.16-.67s.55-2.38-.52-3.27c-.86-.72-2.6.48-3.2,1l-.21.19-.16-.24c-.3-.44-1.24-1.59-1.94-1.59h0a.67.67,0,0,0-.55.38,7,7,0,0,0-1.07,2.5l0,.54-.38-.39a4.44,4.44,0,0,0-2.28-1.37h0a.67.67,0,0,0-.52.25c-.83,1-.43,1.46-.41,1.48l.41.46-.61,0c-1.35-.09-2.87.1-3,.51a1.29,1.29,0,0,0,.24,1.18l.37.39-.53,0s-1.32.11-1.49,1a1.75,1.75,0,0,0,.34,1.49l.15.15-.13.17c-.27.35-.64,1-.59,1.22.5.32,1.79.91,1.8.92l.47.21-.46.24c-.9.47-2.26,1.46-2.08,2.12a2,2,0,0,0,1.42,1.23l.44.11-.32.31c-.25.26-.59.73-.56,1a.19.19,0,0,0,.11.14,1.7,1.7,0,0,0,1,.27l.59-.1-.34.49a.92.92,0,0,0-.17.67s.06.17.34.25a2.92,2.92,0,0,0,1.57.1l.45-.12-.14.44c-.11.33-.23,1.05.07,1.21a2.59,2.59,0,0,0,1.35.08l.53-.12-.26.48a1.19,1.19,0,0,0-.1.79.81.81,0,0,0,.49.47,2,2,0,0,0,1.78,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.1,271.44c-.69,0-1.59-.13-1.91-.77a.73.73,0,0,1,0-.63,2.8,2.8,0,0,1,1.49-1.08,3.26,3.26,0,0,1-1.32-.81.62.62,0,0,1-.13-.65c.21-.44,1.06-.47,1.23-.47a.25.25,0,0,1,.25.25.25.25,0,0,1-.25.25,1.46,1.46,0,0,0-.78.18h0a.91.91,0,0,0,.08.12,3.91,3.91,0,0,0,1.78.88l1,.21-1,.27c-.63.18-1.71.62-1.9,1.05a.2.2,0,0,0,0,.2c.29.6,1.75.52,2.24.44a.25.25,0,0,1,.28.21.25.25,0,0,1-.21.29A6.51,6.51,0,0,1,425.1,271.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,278.07l-.21,0a.82.82,0,0,1-.55-.4c-.41-.72-.08-2.35.23-3.5a2.37,2.37,0,0,1-1.06.75.51.51,0,0,1-.49-.08c-.64.57-1.69,1.28-2.53.68a1,1,0,0,1-.42-.71c-.12-1.05,1.13-2.51,1.28-2.67a.25.25,0,0,1,.37.33c-.35.4-1.23,1.58-1.15,2.28a.49.49,0,0,0,.21.37c.87.62,2.41-1.16,2.42-1.18l.39.32-.11.15a5.53,5.53,0,0,0,1.51-1.54l1-1.46-.59,1.69c-.33.94-1.1,3.55-.65,4.32a.29.29,0,0,0,.2.16.58.58,0,0,0,.46-.11,4.5,4.5,0,0,0,1-2.44l.31-2.09.19,2.1c.06.67.32,1.81.76,2a.46.46,0,0,0,.47-.05c1.17-.67.78-2.86.78-2.88a.24.24,0,0,1,.2-.29.24.24,0,0,1,.29.2c0,.1.46,2.55-1,3.4a.94.94,0,0,1-1,.06,2.07,2.07,0,0,1-.81-1.26,3.2,3.2,0,0,1-1,1.62A1.08,1.08,0,0,1,430,278.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,271.84c-.81,0-1.5-.06-1.66-.07a.26.26,0,0,1-.23-.28.24.24,0,0,1,.28-.22c1.41.13,3.85.12,4.39-.44a.27.27,0,0,0,.08-.24c-.16-1.2-2.44-1.39-2.47-1.39v-.5c1-.11,2.63-.51,2.94-1.06a.33.33,0,0,0,0-.32.25.25,0,0,1,.12-.33.24.24,0,0,1,.33.13.84.84,0,0,1,0,.77,3.46,3.46,0,0,1-2.05,1.08,2.14,2.14,0,0,1,1.65,1.55.81.81,0,0,1-.22.66C441.65,271.72,440.21,271.84,439,271.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.94,277.82c-1.64,0-3.61-2.94-3.83-3.28a.25.25,0,1,1,.41-.27c.56.85,2.26,3.05,3.42,3.05h0a1,1,0,0,0,.8-.6c1.28-2.33-1.59-4.27-1.72-4.35A.26.26,0,0,1,437,272a.26.26,0,0,1,.35-.07s3.38,2.27,1.87,5a1.44,1.44,0,0,1-1.21.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.94,267.41l-.12,0c-.74-.39-3.16-1.71-3.34-2.4a.42.42,0,0,1,0-.33c.28-.44,1.26-.4,2-.3-.82-1-2-2.58-2-3.1a.39.39,0,0,1,.13-.25c.28-.23,1.17,0,2.64.75-.73-1-1-1.68-.89-2a.36.36,0,0,1,.33-.2c.7,0,2.3,2.05,3,2.93a.25.25,0,0,1-.05.35.25.25,0,0,1-.35-.05,14.9,14.9,0,0,0-2.37-2.64,13.55,13.55,0,0,0,1.42,2.14l.74.95-1.05-.58a13.82,13.82,0,0,0-3-1.29,17.71,17.71,0,0,0,2.26,3.16l.47.55-.71-.15a4.48,4.48,0,0,0-2.14-.08,12.13,12.13,0,0,0,3.07,2.06.25.25,0,0,1-.11.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,262h0a.23.23,0,0,1-.24-.25l0-.64a.22.22,0,0,1,.25-.24.25.25,0,0,1,.25.25l0,.64A.25.25,0,0,1,431.86,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.75,265.8h0a.25.25,0,0,1-.24-.25l.09-3.09a.24.24,0,0,1,.25-.24.26.26,0,0,1,.25.26l-.09,3.08A.25.25,0,0,1,431.75,265.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.54,265.2a.28.28,0,0,1-.18-.06.26.26,0,0,1,0-.36l.28-.3a.25.25,0,1,1,.37.35l-.28.29A.23.23,0,0,1,436.54,265.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,266.89a.28.28,0,0,1-.18-.06.26.26,0,0,1,0-.36l1.24-1.32a.25.25,0,0,1,.36,0,.25.25,0,0,1,0,.35l-1.24,1.32A.23.23,0,0,1,435,266.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,270.55h-.06l-.5-.12a.25.25,0,0,1-.18-.3.24.24,0,0,1,.3-.18l.5.11a.27.27,0,0,1,.19.31A.26.26,0,0,1,438.16,270.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.26,270.33h-.06l-1.79-.43a.24.24,0,0,1-.18-.3.25.25,0,0,1,.3-.19l1.78.43a.25.25,0,0,1,.19.3A.26.26,0,0,1,437.26,270.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.78,274a.25.25,0,0,1-.25-.25v-1.61a.25.25,0,0,1,.25-.25.26.26,0,0,1,.25.25v1.61A.26.26,0,0,1,432.78,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.71,272.34a.23.23,0,0,1-.14,0,.25.25,0,0,1-.07-.35l.84-1.22a.24.24,0,0,1,.34-.06.25.25,0,0,1,.07.35l-.84,1.22A.22.22,0,0,1,427.71,272.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.31,265.7a.23.23,0,0,1-.14,0l-.24-.15a.26.26,0,0,1-.07-.35.24.24,0,0,1,.34-.07l.24.15a.26.26,0,0,1,.08.35A.26.26,0,0,1,427.31,265.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.86,266.7a.22.22,0,0,1-.13,0l-1.05-.67a.25.25,0,0,1-.07-.35.24.24,0,0,1,.34-.07l1.05.67a.24.24,0,0,1,.07.34A.22.22,0,0,1,428.86,266.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.15,265.74a.25.25,0,0,1-.24-.18l-.58-2a.25.25,0,0,1,.17-.31.26.26,0,0,1,.31.17l.58,2a.26.26,0,0,1-.18.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3,269.05a4,4,0,1,1-4-3.5A3.77,3.77,0,0,1,436.3,269.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,272.79a3.78,3.78,0,1,1,4.26-3.74A4,4,0,0,1,432.29,272.79Zm0-7a3.28,3.28,0,1,0,3.76,3.25A3.53,3.53,0,0,0,432.29,265.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Firewood--inject-400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.33,399.7l.25-16.51a7.59,7.59,0,0,1,6.34-3.51c4.2.1,8.61,3.78,8.61,3.78L362,408.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,408.74a.5.5,0,0,1-.27-.07l-13.66-8.54a.51.51,0,0,1-.24-.43l.25-16.51a.43.43,0,0,1,.07-.25,8.12,8.12,0,0,1,6.78-3.76c4.33.11,8.74,3.74,8.92,3.9a.49.49,0,0,1,.18.41l-1.54,24.78a.49.49,0,0,1-.27.42A.59.59,0,0,1,362,408.74Zm-13.16-9.31,12.71,7.94L363,383.69c-.89-.69-4.62-3.42-8.12-3.51a6.92,6.92,0,0,0-5.82,3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.19,385.83a.51.51,0,0,1-.5-.45l-.52-4.5a.49.49,0,0,1,.43-.56.51.51,0,0,1,.56.44l.53,4.51a.5.5,0,0,1-.44.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.88,391.19a.5.5,0,0,1-.49-.46l-.28-3a.5.5,0,0,1,1-.09l.27,3a.5.5,0,0,1-.45.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,394a.5.5,0,0,1-.5-.47l-.88-13.76a.5.5,0,0,1,.46-.54.53.53,0,0,1,.54.47l.88,13.77a.5.5,0,0,1-.47.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,385.71a.5.5,0,0,1-.5-.5l-.05-3.5a.51.51,0,0,1,.5-.51.5.5,0,0,1,.5.5l.05,3.5a.51.51,0,0,1-.49.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.84,409.29l-7-15a7.56,7.56,0,0,1,4.17-5.91c3.83-1.75,9.41-.35,9.41-.35l9.4,23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.86,411.53h-.06l-16-1.74a.48.48,0,0,1-.4-.28l-7-15a.57.57,0,0,1,0-.26,8,8,0,0,1,4.47-6.33c3.94-1.79,9.49-.44,9.73-.38a.51.51,0,0,1,.34.3l9.4,23a.5.5,0,0,1-.46.69Zm-15.69-2.71,14.91,1.62-9-22c-1.09-.24-5.65-1.08-8.83.37a7,7,0,0,0-3.87,5.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,395.16a.51.51,0,0,1-.42-.23l-2.43-3.83a.5.5,0,1,1,.84-.53l2.44,3.82a.49.49,0,0,1-.16.69A.43.43,0,0,1,340.05,395.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,399.69a.49.49,0,0,1-.42-.24L341,396.83a.49.49,0,0,1,.17-.68.5.5,0,0,1,.69.17l1.56,2.61a.49.49,0,0,1-.17.69A.48.48,0,0,1,343,399.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,400.91a.49.49,0,0,1-.43-.26l-6.79-12a.5.5,0,0,1,.87-.49l6.79,12a.49.49,0,0,1-.19.68A.45.45,0,0,1,346.84,400.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.06,391.16a.5.5,0,0,1-.45-.28l-1.56-3.13a.49.49,0,0,1,.22-.67.5.5,0,0,1,.67.22l1.57,3.14a.51.51,0,0,1-.22.67A.64.64,0,0,1,348.06,391.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,413.46l7-15a7.6,7.6,0,0,0-4.18-5.92c-3.83-1.74-9.4-.34-9.4-.34l-9.4,23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,415.7a.48.48,0,0,1-.4-.2.51.51,0,0,1-.07-.49l9.4-23a.5.5,0,0,1,.35-.3c.23-.06,5.78-1.42,9.72.38a8,8,0,0,1,4.47,6.33.43.43,0,0,1,0,.25l-7,15a.52.52,0,0,1-.4.29l-16,1.74Zm9.76-23-9,22,14.9-1.62,6.78-14.59a7,7,0,0,0-3.87-5.38C379.13,391.58,374.59,392.42,373.49,392.66Zm6.25,20.8h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.53,399.34a.43.43,0,0,1-.27-.08.51.51,0,0,1-.16-.69l2.44-3.83a.5.5,0,0,1,.69-.15.51.51,0,0,1,.16.69L383,399.11A.51.51,0,0,1,382.53,399.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,403.87a.5.5,0,0,1-.26-.08.49.49,0,0,1-.17-.68l1.57-2.61a.5.5,0,0,1,.85.51L380,403.62A.51.51,0,0,1,379.57,403.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.74,405.08a.54.54,0,0,1-.25-.06.51.51,0,0,1-.19-.68l6.79-12a.5.5,0,0,1,.87.49l-6.79,12A.5.5,0,0,1,375.74,405.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.52,395.34a.43.43,0,0,1-.22-.06.5.5,0,0,1-.23-.67l1.57-3.13a.5.5,0,0,1,.89.45L375,395.06A.5.5,0,0,1,374.52,395.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82,407.19l.24-16.51a7.61,7.61,0,0,1,6.34-3.51c4.21.1,8.62,3.78,8.62,3.78l-1.54,24.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.48,416.23a.56.56,0,0,1-.27-.08l-13.66-8.54a.47.47,0,0,1-.23-.43l.24-16.51a.55.55,0,0,1,.07-.25,8.17,8.17,0,0,1,6.78-3.75c4.33.1,8.74,3.74,8.93,3.89a.51.51,0,0,1,.17.42L370,415.76a.49.49,0,0,1-.27.41A.46.46,0,0,1,369.48,416.23Zm-13.16-9.32L369,414.86l1.47-23.69c-.88-.68-4.62-3.42-8.11-3.5a7.05,7.05,0,0,0-5.83,3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.67,393.31a.5.5,0,0,1-.49-.44l-.53-4.51a.5.5,0,0,1,1-.11l.53,4.5a.5.5,0,0,1-.44.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.37,398.67a.49.49,0,0,1-.5-.45l-.27-3a.5.5,0,0,1,.45-.55.5.5,0,0,1,.54.46l.28,3a.5.5,0,0,1-.46.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.29,401.44a.5.5,0,0,1-.5-.47l-.89-13.77a.5.5,0,0,1,.47-.53.52.52,0,0,1,.53.47l.89,13.76a.52.52,0,0,1-.47.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.63,393.19a.49.49,0,0,1-.5-.49l-.05-3.5a.5.5,0,0,1,.49-.51h0a.51.51,0,0,1,.5.49l.05,3.5a.5.5,0,0,1-.5.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.56 405.01 336.94 405.01 341.9 441.04 381.6 441.04 386.56 405.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,441.54H341.9a.5.5,0,0,1-.49-.43l-5-36a.46.46,0,0,1,.12-.39.49.49,0,0,1,.37-.18h49.62a.53.53,0,0,1,.38.18.49.49,0,0,1,.11.39l-5,36A.5.5,0,0,1,381.6,441.54Zm-39.26-1h38.82l4.83-35H337.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dishes-2--inject-400"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 409.68,
    cy: 152.02,
    r: 24.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.68,177.16A25.14,25.14,0,1,1,434.82,152,25.16,25.16,0,0,1,409.68,177.16Zm0-49.28A24.14,24.14,0,1,0,433.82,152,24.17,24.17,0,0,0,409.68,127.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.68,
    cy: 152.02,
    r: 14.43,
    transform: "translate(-26.93 169.95) rotate(-22.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.68,167A14.93,14.93,0,1,1,424.6,152,15,15,0,0,1,409.68,167Zm0-28.86A13.93,13.93,0,1,0,423.6,152,13.95,13.95,0,0,0,409.68,138.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.52,
    cy: 183.93,
    r: 21.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.52,206.12a22.19,22.19,0,1,1,22.19-22.19A22.22,22.22,0,0,1,454.52,206.12Zm0-43.38a21.19,21.19,0,1,0,21.19,21.19A21.21,21.21,0,0,0,454.52,162.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.52,
    cy: 183.93,
    r: 12.7,
    transform: "translate(-35.77 189.52) rotate(-22.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.52,197.13a13.2,13.2,0,1,1,13.2-13.2A13.21,13.21,0,0,1,454.52,197.13Zm0-25.4a12.2,12.2,0,1,0,12.2,12.2A12.21,12.21,0,0,0,454.52,171.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.5,
    cy: 201.92,
    r: 19.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,221.52a19.6,19.6,0,1,1,19.6-19.6A19.63,19.63,0,0,1,412.5,221.52Zm0-38.2a18.6,18.6,0,1,0,18.6,18.6A18.63,18.63,0,0,0,412.5,183.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.5,
    cy: 201.92,
    r: 11.18,
    transform: "translate(126.83 561.53) rotate(-77.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,213.6a11.68,11.68,0,1,1,11.68-11.68A11.69,11.69,0,0,1,412.5,213.6Zm0-22.36a10.68,10.68,0,1,0,10.68,10.68A10.69,10.69,0,0,0,412.5,191.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dishes-1--inject-400"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.33,
    cy: 152.02,
    r: 24.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,177.16A25.14,25.14,0,1,1,119.47,152,25.17,25.17,0,0,1,94.33,177.16Zm0-49.28A24.14,24.14,0,1,0,118.47,152,24.17,24.17,0,0,0,94.33,127.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.33,
    cy: 152.02,
    r: 14.43,
    transform: "translate(-82.22 180.99) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,167A14.93,14.93,0,1,1,109.26,152,15,15,0,0,1,94.33,167Zm0-28.86A13.93,13.93,0,1,0,108.26,152,13.95,13.95,0,0,0,94.33,138.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.49,
    cy: 183.93,
    r: 21.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,206.12a22.19,22.19,0,1,1,22.19-22.19A22.22,22.22,0,0,1,49.49,206.12Zm0-43.38a21.19,21.19,0,1,0,21.19,21.19A21.22,21.22,0,0,0,49.49,162.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.49,
    cy: 183.93,
    r: 12.7,
    transform: "translate(-124.13 105.59) rotate(-50.66)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,197.13a13.2,13.2,0,1,1,13.19-13.2A13.21,13.21,0,0,1,49.49,197.13Zm0-25.4a12.2,12.2,0,1,0,12.19,12.2A12.21,12.21,0,0,0,49.49,171.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.51,
    cy: 201.92,
    r: 19.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.51,221.52a19.6,19.6,0,1,1,19.6-19.6A19.62,19.62,0,0,1,91.51,221.52Zm0-38.2a18.6,18.6,0,1,0,18.6,18.6A18.62,18.62,0,0,0,91.51,183.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.51,
    cy: 201.92,
    r: 11.18,
    transform: "translate(-130.06 209.19) rotate(-67.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.51,213.6a11.68,11.68,0,1,1,11.68-11.68A11.69,11.69,0,0,1,91.51,213.6Zm0-22.36a10.68,10.68,0,1,0,10.68,10.68A10.69,10.69,0,0,0,91.51,191.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.16,322.84c.79-9.94-3.93-16.61-20-14.41-13.55,1.84-23.82,7.43-34,8.23-10.2-.8-20.47-6.39-34-8.23-5.89-.81-16,.38-19.55,6.75-4.13,7.37.76,21.61,3.85,28.22,6.09,13.05,11.6,29.38,18.12,42.22l21.87,3h19.43l21.87-3C156.19,376.76,172.84,339.44,174.16,322.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.16,322.84c.79-9.94-3.93-16.61-20-14.41-13.55,1.84-23.82,7.43-34,8.23-10.2-.8-20.47-6.39-34-8.23-5.89-.81-16,.38-19.55,6.75-4.13,7.37.76,21.61,3.85,28.22,6.09,13.05,11.6,29.38,18.12,42.22l21.87,3h19.43l21.87-3C156.19,376.76,172.84,339.44,174.16,322.84Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,389.12l-21.93-3a.48.48,0,0,1-.38-.26c-3.66-7.21-7-15.59-10.3-23.69-2.54-6.3-5.16-12.81-7.84-18.55-3.36-7.19-7.94-21.32-3.83-28.68,3.71-6.63,14-7.82,20-7a109,109,0,0,1,18.33,4.53c5.46,1.7,10.61,3.3,15.65,3.7,5-.4,10.12-2,15.58-3.7a109,109,0,0,1,18.33-4.53c8-1.09,13.8,0,17.15,3.12,2.71,2.57,3.87,6.55,3.45,11.83-1.33,16.82-17.94,54-22.52,63-.11.24-.11.24-22.24,3.28Zm-21.54-4,21.61,3h19.36l21.54-3c4.55-9,21-46.06,22.3-62.36h0c.39-5-.67-8.67-3.15-11-3.12-2.95-8.61-3.91-16.33-2.86A109.11,109.11,0,0,0,136,313.41c-5.51,1.72-10.72,3.34-15.88,3.74-5.23-.4-10.44-2-16-3.74A109.11,109.11,0,0,0,86,308.92c-5.54-.75-15.6.34-19,6.5-3.91,7,.59,20.75,3.87,27.77,2.69,5.76,5.32,12.28,7.86,18.59C81.93,369.78,85.25,378.05,88.85,385.16Zm62.84.46h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.48,357.82s-3.45.11-6,6.76-.38,14.64-4.47,18.1,6.05,2.82,8.59-4.47S156.48,357.82,156.48,357.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31,385.2c-1.2,0-1.57-.5-1.68-.81-.22-.6.14-1.31,1.08-2.1,2.21-1.86,2.46-5.21,2.76-9.08A31.35,31.35,0,0,1,150,364.4c2.62-6.89,6.28-7.07,6.43-7.08a.54.54,0,0,1,.52.48c0,.54.65,13.28-1.89,20.57a10.34,10.34,0,0,1-8.73,6.83ZM156,358.44c-1,.33-3.24,1.59-5,6.32a30.33,30.33,0,0,0-1.49,8.53c-.3,3.92-.59,7.63-3.12,9.77-.8.68-.78,1-.78,1s.34.23,1.19.14a9.58,9.58,0,0,0,7.38-6.14C156.31,371.8,156.09,361.07,156,358.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.54,
    y: 398.86,
    width: 66.21,
    height: 14.71,
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,414.07H86V398.36h67.21Zm-66.21-1h65.21V399.36H87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,398.86l-9.83,40.28a1.53,1.53,0,0,0,1.48,1.9h0a1.53,1.53,0,0,0,1.4-.91L96.84,401.8Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,441.54a2,2,0,0,1-2-2.52l10-40.78,11.36,3.24L80.05,440.34A2,2,0,0,1,78.19,441.54Zm8.71-42.06-9.71,39.78a1.06,1.06,0,0,0,.19.88,1.08,1.08,0,0,0,1.76-.21l17-37.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.15,398.86,164,439.14a1.54,1.54,0,0,1-1.49,1.9h0a1.55,1.55,0,0,1-1.4-.91L143.85,401.8Z",
    style: {
      fill: "#E5383B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5,441.54a2,2,0,0,1-1.85-1.2l-17.49-38.86,11.35-3.24,10,40.78a2,2,0,0,1-.37,1.74A2,2,0,0,1,162.5,441.54Zm-17.95-39.42,17,37.81a1.07,1.07,0,0,0,1.75.21,1,1,0,0,0,.19-.88l-9.71-39.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62,362.68c-.81-12.14-12.14-4.86-12.14-4.86-5.67,4.86-3.24,24.05-10.53,24.86-6.2.68-21.77,1.37-26.28,1.56-4.51-.19-20.09-.88-26.29-1.56-7.29-.81-4.86-20-10.52-24.86,0,0-11.34-7.28-12.15,4.86s5.67,34,13,38.87c6.77,4.52,23.34,5.53,34.75,5.66h2.49c11.41-.13,28-1.14,34.76-5.66C163,396.69,169.43,374.83,168.62,362.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62,362.68c-.81-12.14-12.14-4.86-12.14-4.86-5.67,4.86-3.24,24.05-10.53,24.86-6.2.68-21.77,1.37-26.28,1.56-4.51-.19-20.09-.88-26.29-1.56-7.29-.81-4.86-20-10.52-24.86,0,0-11.34-7.28-12.15,4.86s5.67,34,13,38.87c6.77,4.52,23.34,5.53,34.75,5.66h2.49c11.41-.13,28-1.14,34.76-5.66C163,396.69,169.43,374.83,168.62,362.68Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91,407.72h-2.62c-12.23-.14-28.16-1.25-34.9-5.74-7.51-5-14-27.1-13.18-39.32.24-3.56,1.39-5.89,3.43-6.91,3.82-1.93,9.26,1.51,9.49,1.66,2.74,2.35,3.67,7.58,4.58,12.63,1.08,6,2.09,11.74,5.73,12.15,6.15.68,21.64,1.37,26.25,1.56,4.56-.19,20.05-.88,26.2-1.56,3.64-.41,4.66-6.11,5.73-12.15.91-5,1.84-10.28,4.53-12.59.29-.19,5.72-3.63,9.54-1.7,2,1,3.19,3.35,3.43,6.91h0c.82,12.22-5.67,34.31-13.18,39.32-6.74,4.49-22.68,5.6-34.91,5.74Zm-1.27-1h1.27c9.91-.11,27.57-1,34.48-5.58,7.07-4.71,13.52-26.58,12.73-38.42h0c-.21-3.18-1.18-5.22-2.88-6.08-3.31-1.67-8.44,1.58-8.49,1.61-2.37,2-3.27,7.09-4.14,12-1.15,6.41-2.23,12.48-6.61,13-6.18.69-21.7,1.38-26.31,1.57-4.66-.19-20.18-.88-26.36-1.57-4.38-.48-5.46-6.55-6.61-13-.87-4.88-1.77-9.93-4.19-12h0s-5.14-3.24-8.44-1.57c-1.7.86-2.67,2.9-2.88,6.08-.79,11.84,5.66,33.71,12.73,38.42,6.91,4.61,24.57,5.47,34.48,5.58h1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.27,407.14h.15c11.08-.29,25.2-1.51,31.33-5.59,7.78-15.45,4.13-21.1,1.53-22.31-3.1-1.44-5.6.42-8.61,2a4,4,0,0,1-2.64,1.46c-4.19.46-12.66.93-19.1,1.24h0l-7.22.33-7.23-.33h0c-6.44-.31-14.91-.78-19.1-1.24a4,4,0,0,1-2.64-1.46c-3-1.56-5.51-3.42-8.61-2-2.59,1.21-6.25,6.86,1.54,22.31,6.12,4.08,20.24,5.3,31.33,5.59h.14l1.6,0h.51l1.17,0H121l1.17,0h.51Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,407.72h-2.62l-1.64,0-1.6,0H115c-11-.28-25.33-1.5-31.59-5.67a.61.61,0,0,1-.17-.19C77.87,391.15,78,385.33,79,382.31a5.71,5.71,0,0,1,2.88-3.52c2.9-1.35,5.31-.05,7.85,1.34l1.2.64a.44.44,0,0,1,.15.12,3.52,3.52,0,0,0,2.32,1.29c4.17.46,12.63.93,19,1.24h.06l7.22.32,7.17-.32H127c6.38-.31,14.85-.78,19-1.24a3.52,3.52,0,0,0,2.32-1.29l.15-.12,1.2-.64c2.55-1.39,5-2.69,7.85-1.34a5.71,5.71,0,0,1,2.88,3.52c1,3,1.17,8.84-4.18,19.47a.51.51,0,0,1-.17.19c-6.26,4.17-20.64,5.39-31.59,5.67h-.15l-1.6,0-1.56,0Zm0-.5h0Zm3.27-.58v.5l.06-.5c10.83-.28,24.9-1.45,31-5.43,5.13-10.24,5-15.75,4.06-18.57a4.77,4.77,0,0,0-2.35-2.94c-2.45-1.14-4.53,0-6.95,1.31l-1.14.61a4.45,4.45,0,0,1-2.9,1.55c-4.2.47-12.72.94-19.13,1.25h0l-7.17.32-7.22-.32h-.05c-6.41-.31-14.93-.78-19.13-1.25a4.48,4.48,0,0,1-2.9-1.55L89.29,381c-2.42-1.32-4.5-2.45-7-1.31A4.77,4.77,0,0,0,80,382.64c-1,2.82-1.07,8.33,4.06,18.57,6.13,4,20.2,5.15,31,5.43l.13.5v-.5l1.6,0,1.67,0H121l1.67,0,1.6,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-400"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.19,
    y: 92.91,
    width: 134.12,
    height: 160.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.32,253.76H186.19a.5.5,0,0,1-.5-.5V92.91a.51.51,0,0,1,.5-.5H320.32a.51.51,0,0,1,.5.5V253.26A.5.5,0,0,1,320.32,253.76Zm-133.63-1H319.82V93.41H186.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 98.75,
    width: 124.35,
    height: 148.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43,247.92H191.08a.5.5,0,0,1-.5-.5V98.75a.5.5,0,0,1,.5-.5H315.43a.5.5,0,0,1,.5.5V247.42A.5.5,0,0,1,315.43,247.92Zm-123.85-1H314.93V99.25H191.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.28,
    y: 106.63,
    width: 48.5,
    height: 57.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.79,165.12H198.28a.51.51,0,0,1-.5-.5v-58a.5.5,0,0,1,.5-.5h48.51a.5.5,0,0,1,.5.5v58A.51.51,0,0,1,246.79,165.12Zm-48-1h47.51v-57H198.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.23,
    y: 132.62,
    width: 48.5,
    height: 57.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,191.11h-48.5a.5.5,0,0,1-.5-.5v-58a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5v58A.5.5,0,0,1,286.73,191.11Zm-48-1h47.5v-57h-47.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.25,
    y: 205.44,
    width: 25.82,
    height: 30.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,236.81H214.25a.5.5,0,0,1-.5-.5V205.44a.51.51,0,0,1,.5-.5h25.83a.51.51,0,0,1,.5.5v30.87A.5.5,0,0,1,240.08,236.81Zm-25.33-1h24.83V205.94H214.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.22,
    y: 205.44,
    width: 25.82,
    height: 30.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,236.81H247.22a.5.5,0,0,1-.5-.5V205.44a.51.51,0,0,1,.5-.5H273a.5.5,0,0,1,.5.5v30.87A.5.5,0,0,1,273,236.81Zm-25.32-1h24.82V205.94H247.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.9,
    y: 191.17,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27,212.45H289.9a.5.5,0,0,1-.5-.5V191.17a.5.5,0,0,1,.5-.5h17.37a.5.5,0,0,1,.5.5V212A.5.5,0,0,1,307.27,212.45Zm-16.87-1h16.37V191.67H290.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.16,
    y: 164.95,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.54,186.22H277.16a.5.5,0,0,1-.5-.5V165a.5.5,0,0,1,.5-.5h17.38a.5.5,0,0,1,.5.5v20.77A.5.5,0,0,1,294.54,186.22Zm-16.88-1H294V165.45H277.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.25,
    y: 106.63,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.62,127.9H253.25a.5.5,0,0,1-.5-.5V106.63a.5.5,0,0,1,.5-.5h17.37a.5.5,0,0,1,.5.5V127.4A.5.5,0,0,1,270.62,127.9Zm-16.87-1h16.37V107.13H253.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.22,
    y: 172.64,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,193.91H198.22a.5.5,0,0,1-.5-.5V172.64a.5.5,0,0,1,.5-.5h17.37a.5.5,0,0,1,.5.5v20.77A.5.5,0,0,1,215.59,193.91Zm-16.87-1h16.37V173.14H198.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.54,
    y: 180.22,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,201.49H229.54a.5.5,0,0,1-.5-.5V180.22a.5.5,0,0,1,.5-.5h17.38a.5.5,0,0,1,.5.5V201A.5.5,0,0,1,246.92,201.49Zm-16.88-1h16.38V180.72H230Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.48,
    y: 106.63,
    width: 29.3,
    height: 35.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,142.16h-29.3a.5.5,0,0,1-.5-.5v-35a.5.5,0,0,1,.5-.5h29.3a.5.5,0,0,1,.5.5v35A.5.5,0,0,1,305.78,142.16Zm-28.8-1h28.3v-34H277Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.9,
    y: 215.71,
    width: 17.37,
    height: 20.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27,237H289.9a.5.5,0,0,1-.5-.5V215.71a.5.5,0,0,1,.5-.5h17.37a.5.5,0,0,1,.5.5v20.77A.5.5,0,0,1,307.27,237Zm-16.87-1h16.37V216.21H290.4Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesBro);
export default __webpack_public_path__ + "static/media/Images-bro.d20a7f11c3e783483e07526598cebc10.svg";
export { ForwardRef as ReactComponent };